/* Milagron · renk adı → arka plan (renk listesi + bileşik adlar + desenler) */
var MGC_PAT = { 'çizgili': 'cizgili', 'cizgili': 'cizgili', 'puantiye': 'puantiye', 'puantiyeli': 'puantiye', 'benekli': 'puantiye', 'desenli': 'desen', 'desen': 'desen', 'ekose': 'ekose', 'ekoseli': 'ekose', 'kareli': 'ekose', 'leopar': 'leopar', 'zebra': 'zebra', 'kamuflaj': 'kamuflaj', 'çiçek': 'cicek', 'çiçekli': 'cicek', 'çok renkli': 'cok', 'renkli': 'cok', 'multi': 'cok', 'multicolor': 'cok', 'hologram': 'cok', 'patchwork': 'cok' };
function mgcNorm(s) { return String(s || '').toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim(); }
function mgcResolve(name, map) {
  var k = mgcNorm(name), v = map[k];
  if (v) return v;
  var hex = [], pat = '';
  k.split(/\s*[\/&,+]\s*|\s+-\s+|\s+ve\s+/).filter(Boolean).forEach(function (p) {
    if (MGC_PAT[p]) { pat = pat || MGC_PAT[p]; return; }
    var x = map[p];
    if (!x) {
      var w = p.split(' ');
      w.forEach(function (t) { if (MGC_PAT[t]) pat = pat || MGC_PAT[t]; });
      var base = w.filter(function (t) { return !MGC_PAT[t]; });
      x = map[base.join(' ')];
      for (var n = base.length - 1; !x && n > 0; n--) {
        for (var s = 0; s + n <= base.length && !x; s++) x = map[base.slice(s, s + n).join(' ')];
      }
    }
    if (x) {
      var h = x.match(/#[0-9a-f]{3,8}/gi); if (h) hex = hex.concat(h);
      var d = /desen:([a-zçğıöşü]+)/i.exec(x); if (d) pat = pat || d[1];
    }
  });
  if (!hex.length && !pat) return '';
  return hex.join('') + (pat ? 'desen:' + pat : '');
}
function mgcLight(h) {
  h = h.replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
  var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150;
}
function mgcBg(v) {
  if (!v) return '';
  v = String(v).replace(/desen:/g, ' desen:');
  var h = v.match(/#[0-9a-f]{3,8}/gi) || [];
  var d = (/desen:([a-zçğıöşü]+)/i.exec(v) || [])[1] || '';
  if (/^(cok|desen|cicek)$/.test(d) && h.length < 2) h = ['#e4572e', '#f2c230', '#3fa34d', '#2f6bd8'];
  if (d === 'cok' && h.length < 4) h = ['#e4572e', '#f2c230', '#3fa34d', '#2f6bd8'];
  var base = h[0] || '#ffffff', alt = h[1] || (mgcLight(base) ? '#1f2a44' : '#ffffff');
  if (d === 'puantiye') return 'radial-gradient(circle, ' + alt + ' 24%, transparent 28%) 0 0/7px 7px, ' + base;
  if (d === 'cizgili') return 'repeating-linear-gradient(135deg, ' + base + ' 0 3px, ' + alt + ' 3px 5px)';
  if (d === 'zebra') return 'repeating-linear-gradient(135deg, #f7f6f2 0 3px, #1a1a1a 3px 6px)';
  if (d === 'leopar') return 'radial-gradient(circle, #3b2a1a 26%, transparent 32%) 0 0/7px 7px, radial-gradient(circle, #3b2a1a 20%, transparent 26%) 3.5px 3.5px/7px 7px, #c8a165';
  if (d === 'ekose') return 'repeating-linear-gradient(0deg, rgba(0,0,0,.28) 0 2px, transparent 2px 6px), repeating-linear-gradient(90deg, rgba(0,0,0,.28) 0 2px, transparent 2px 6px), ' + (h[0] || '#b5302c');
  if (d === 'kamuflaj') return 'radial-gradient(circle at 30% 30%, #5b6b2c 30%, transparent 32%), radial-gradient(circle at 70% 65%, #3b3d2a 28%, transparent 30%), #8a7a5c';
  if (!h.length) return /^https?:|^\/\//.test(v) ? 'center/cover url("' + v + '")' : '';
  if (h.length === 1) return h[0];
  var st = 100 / h.length, parts = h.map(function (x, i) { return x + ' ' + (i * st) + '% ' + ((i + 1) * st) + '%'; });
  if (h.length >= 4) return 'conic-gradient(' + parts.join(',') + ')';
  return 'linear-gradient(135deg,' + parts.join(',') + ')';
}

/* =========================================================================
   Milagron · Ürün kartı kampanya kutusu (44 px)
   -------------------------------------------------------------------------
   Ürün kartlarındaki .custom-tag-rotator--below şeridini yapılandırılmış
   kutuya çevirir: solda büyük değer (%25 / %10 / 3×), sağda iki satır,
   kod içeren kampanyada kopyalanabilir kod çipi.

   Veri kaynağı değişmedi: discount-badge.liquid'in ürettiği data-efx-tags
   JSON'u (panelden yönetilen shop.metafields.badges.discount). Metin,
   oran, kod, fiyat, hangi üründe hangi badge'in çıkacağı yine panelden
   gelir; bu dosya yalnız görünümü kurar.

   Tür tanıma (metinden):
     - sonunda fiyat + metinde %NN  -> sepet  (yeşil)
     - "Kod: XXXX"                 -> kod    (turuncu, kopyala çipi)
     - "N Taksit"                  -> taksit (mavi)
     - diğer                       -> genel  (siyah)

   Eski rotator (layout/theme.liquid) aynı düğümü efxInit bayrağı kurulu
   gördüğü için atlar. Bu dosya o script'ten ÖNCE (head başında, defer'siz)
   yüklenmeli ki MutationObserver ve DOMContentLoaded sırası bizde olsun.
   Marka Vitrini rotator'larında --below sınıfı yok, onlara dokunulmaz.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgCbox) return;
  window.__mgCbox = true;

  var SEL = '.custom-tag-rotator--below';
  // Marka Vitrini section'ındaki dönen etiket: aynı kutu, section renklerine uyan sade hâli
  var VIT_SEL = '.efx-bs__tags.custom-tag-rotator';
  var ROT_SEL = SEL + ', ' + VIT_SEL;
  var FADE = 220;
  // Renkler Tema ayarları > Milagron Özel Ayarlar'dan CSS değişkeni olarak gelir
  var ACC = {
    sepet: 'var(--mg-c-sepet, #0B7A43)',
    kod: 'var(--mg-c-kod, #B35A00)',
    taksit: 'var(--mg-c-taksit, #1D3FA8)',
    genel: 'var(--mg-c-genel, #141414)'
  };
  // Davranış ayarları: doc-head-core.liquid window.MG_CBOX olarak basar
  function cfg(k, d) {
    var c = window.MG_CBOX || {};
    return c[k] === undefined || c[k] === null ? d : c[k];
  }
  var COPY_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';


  function clean(s) {
    return String(s == null ? '' : s).replace(/\s{2,}/g, ' ').trim();
  }
  function dropPercent(s) {
    return clean(String(s).replace(/%\s*\d+(?:[.,]\d+)?\s*/, ''));
  }

  // Fiyat: "3.599,25 TL", "₺3.599,25", "3.599 TL"
  var PRICE_RE = /\s((?:₺\s?)?\d[\d.]*,\d{1,2}(?:\s?(?:TL|₺))?|(?:₺\s?)?\d[\d.]*\s?(?:TL|₺))\s*$/;

  function parse(it) {
    var text = clean(it.text);
    var pct = /%\s*(\d+(?:[.,]\d+)?)/.exec(text);

    // 1) Sepet: oranlı badge, sonunda hesaplanmış fiyat var
    //    (yeni alanlar gelirse onları kullan: base / rate / suffix / price)
    if (it.price && it.rate != null && it.rate !== '') {
      return {
        kind: 'sepet',
        big: '%' + String(it.rate).replace('.', ','),
        l1: dropPercent(it.base || text) || 'Sepette İndirim',
        sfx: clean(it.suffix),
        price: clean(it.price)
      };
    }
    var pm = pct ? PRICE_RE.exec(text) : null;
    if (pct && pm) {
      var rest = clean(text.slice(0, pm.index));
      var low = rest.toLocaleLowerCase('tr');
      var at = low.lastIndexOf('indirim');
      var head = rest,
        sfx = '';
      if (at >= 0) {
        head = rest.slice(0, at + 7);
        sfx = clean(rest.slice(at + 7));
      }
      return { kind: 'sepet', big: '%' + pct[1], l1: dropPercent(head) || 'Sepette İndirim', sfx: sfx, price: clean(pm[1]) };
    }

    // 2) Kodlu kampanya: "... %10 İndirim | Kod: MILAGRON10"
    var cm = /Kod\s*:\s*([A-Za-z0-9_-]+)/i.exec(text);
    if (cm) {
      var h = clean(text.split('|')[0].replace(/Kod\s*:\s*[A-Za-z0-9_-]+/i, ''));
      var hp = /%\s*(\d+)/.exec(h);
      return { kind: 'kod', big: hp ? '%' + hp[1] : '%', l1: dropPercent(h), code: cm[1] };
    }

    // 3) Taksit
    var tm = /(\d+)\s*Taksit/i.exec(text);
    if (tm) return { kind: 'taksit', big: tm[1] + '×', l1: text };

    // 4) Genel
    return { kind: 'genel', big: pct ? '%' + pct[1] : '', l1: pct ? dropPercent(text) : text };
  }

  var toastEl = null, toastT = null;
  function toast(code) {
    try {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'mg-cbox-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = '';
      var ic = document.createElement('span');
      ic.className = 'mg-cbox-toast__ic';
      ic.textContent = '✓';
      var b = document.createElement('b');
      b.textContent = code;
      toastEl.appendChild(ic);
      toastEl.appendChild(b);
      toastEl.appendChild(document.createTextNode(' ' + cfg('toastText', 'kopyalandı')));
      toastEl.classList.remove('is-on');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
    } catch (e) {}
  }

  // ---- Satış fiyatı: kartta .product-price, ürün sayfasında yakındaki fiyat alanı
  var MONEY_RE = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/;
  function moneyOf(t) {
    var m = MONEY_RE.exec(String(t || ''));
    return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : 0;
  }
  function priceEl(node) {
    var vc = node.closest('.efx-bs__card');
    if (vc) return vc.querySelector('.efx-bs__price-now');
    var pb = node.closest('.product-block');
    if (pb) return pb.querySelector('.product-price');
    var up = node.parentElement;
    for (var k = 0; up && k < 8; k++, up = up.parentElement) {
      var f = up.querySelector('.product-price, .price-container, .product-detail__price, .price');
      if (f && !node.contains(f) && moneyOf(f.textContent)) return f;
    }
    return null;
  }
  function fmtTL(v) {
    try {
      return v.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    } catch (e) {
      return v.toFixed(2).replace('.', ',') + ' TL';
    }
  }

  // ---- Sepet fiyatı fiyatın yanında: mevcut fiyat çizilir, altına "Sepette X TL"
  function rateOf(p) {
    return parseFloat(String(p.big || '').replace('%', '').replace(',', '.')) || 0;
  }
  function applySepetPrice(scope, rate) {
    if (!scope || !rate || !cfg('sepetFiyat', true)) return;
    var box = scope.querySelector('.efx-bs__price') || scope.querySelector('.price');
    if (!box) return;
    var curEl = box.querySelector('.price__current') || box.querySelector('.efx-bs__price-now');
    if (!curEl) return;
    var draw = function () {
      var cur = moneyOf(curEl.textContent);
      var sp = box.querySelector('.mg-sp');
      if (!cur) { if (sp) sp.remove(); box.classList.remove('mg-sp-on'); return; }
      if (!sp) {
        sp = el('div', 'mg-sp');
        sp.appendChild(el('span', 'mg-sp__val'));
        sp.appendChild(el('span', 'mg-sp__tag'));
        box.appendChild(sp);
      }
      var val = fmtTL(Math.round(cur * (100 - rate)) / 100);
      if (sp.firstChild.textContent !== val) sp.firstChild.textContent = val;
      var lbl = cfg('sepetLabel', 'Sepette');
      if (sp.lastChild.textContent !== lbl) sp.lastChild.textContent = lbl;
      box.classList.add('mg-sp-on');
    };
    draw();
    // Ürün sayfasında varyant değişince fiyat değişir
    if (!curEl._mgSpWatch && 'MutationObserver' in window) {
      curEl._mgSpWatch = true;
      new MutationObserver(draw).observe(curEl, { childList: true, subtree: true, characterData: true });
    }
  }
  function sepetFromItems(items) {
    for (var k = 0; k < items.length; k++) {
      var p = parse(items[k]);
      if (p.kind === 'sepet') return rateOf(p);
    }
    return 0;
  }
  function sepetRateFor(node) {
    if (node._mgItems) return sepetFromItems(node._mgItems);
    var box = node.parentElement;
    if (!box) return 0;
    var tags = box.querySelectorAll('.custom-tag:not(.custom-tag-rotator)');
    for (var k = 0; k < tags.length; k++) {
      var t = tags[k].getAttribute('data-mg-text') || tags[k].textContent;
      var p = parse({ text: t });
      if (p.kind === 'sepet') return rateOf(p);
    }
    return 0;
  }
  function pdpScope(node) {
    var up = node.parentElement;
    for (var k = 0; up && k < 8; k++, up = up.parentElement) {
      var pr = up.querySelector('.price .price__current');
      if (pr && !node.contains(pr)) return pr.closest('.price').parentElement;
    }
    return null;
  }

  // Dar kutuda metni kesmek yerine kısaltır: önce bilinen kısa biçim,
  // sonra sondan kelime atar (en az 2 kelime kalır). Sığan ilk biçim yazılır.
  // Sığma ölçümü: metnin gerçek genişliği (alt piksel dahil) kutudan büyükse taşar
  function overflows(node) {
    var r = document.createRange();
    r.selectNodeContents(node);
    return r.getBoundingClientRect().width > node.clientWidth - 0.5;
  }
  var FIT_NODES = [];
  function doFit(node) {
    var text = node._mgFitText;
    if (!text || !node.isConnected || !node.clientWidth) return;
    var short = text.replace(/Alışverişinize/i, 'Alışverişe').replace(/Alışverişiniz/i, 'Alışveriş');
    var w = short.split(' ');
    // Sıra: tam metin, tam metin küçük, kısa metin, kısa metin küçük, sondan kelime atarak (küçük)
    var cands = [[text, 1], [text, 0.92]];
    if (short !== text) cands.push([short, 1], [short, 0.92]);
    for (var n = w.length - 1; n >= 2; n--) cands.push([w.slice(0, n).join(' '), 0.92]);
    node.style.removeProperty('font-size');
    var base = parseFloat(getComputedStyle(node).fontSize) || 10;
    for (var k = 0; k < cands.length; k++) {
      node.textContent = cands[k][0];
      if (cands[k][1] === 1) node.style.removeProperty('font-size');
      else node.style.setProperty('font-size', (base * cands[k][1]) + 'px', 'important');
      if (!overflows(node)) return;
    }
  }
  // Dar kutuda metni kesmek yerine sığdırır; yazı tipi geç yüklenirse yeniden ölçer.
  function fitWords(node, text) {
    if (!node) return;
    node._mgFitText = text;
    if (FIT_NODES.indexOf(node) < 0) FIT_NODES.push(node);
    requestAnimationFrame(function () { doFit(node); });
  }
  var refitT;
  function refitAll() {
    clearTimeout(refitT);
    refitT = setTimeout(function () {
      FIT_NODES = FIT_NODES.filter(function (n) { return n.isConnected; });
      FIT_NODES.forEach(doFit);
    }, 80);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitAll);
  window.addEventListener('load', refitAll);
  window.addEventListener('resize', refitAll);

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }

  function copyText(t) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(t).catch(function () {
          fallbackCopy(t);
        });
      }
    } catch (e) {}
    fallbackCopy(t);
    return Promise.resolve();
  }
  function fallbackCopy(t) {
    try {
      var ta = document.createElement('textarea');
      ta.value = t;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0;';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {}
  }

  function render(node, inner, it) {
    var p = parse(it || {});
    var acc = ACC[p.kind];
    // Genel türde panel rengi (beyaz değilse) vurgu olur
    if (p.kind === 'genel' && it && it.bg && !/^#?(fff|ffffff)$/i.test(String(it.bg).trim())) acc = it.bg;

    node.style.setProperty('--mg-acc', acc);
    node.setAttribute('data-mg-kind', p.kind);
    node.classList.toggle('mg-cbox--nobig', !p.big);

    inner.textContent = '';
    inner.appendChild(el('span', 'mg-cbox__big', p.big));
    inner.appendChild(el('span', 'mg-cbox__sep'));
    var txt = el('span', 'mg-cbox__txt');
    txt.appendChild(el('span', 'mg-cbox__l1', p.l1));

    if (p.kind === 'sepet') {
      var l2 = el('span', 'mg-cbox__l2');
      if (p.sfx) l2.appendChild(el('span', 'mg-cbox__sfx', p.sfx));
      l2.appendChild(el('b', 'mg-cbox__price', p.price));
      txt.appendChild(l2);
      inner.appendChild(txt);
      // Dar kartta fiyat sığmazsa önek ("Sadece") gizlenir, fiyat kesilmez
      requestAnimationFrame(function () {
        if (l2.scrollWidth > l2.clientWidth + 1) l2.classList.add('mg-cbox__l2--nosfx');
      });
    } else if (p.kind === 'kod') {
      var row = el('span', 'mg-cbox__l2');
      var btn = el('button', 'mg-cbox__chip');
      btn.type = 'button';
      btn.setAttribute('aria-label', p.code + ' kodunu kopyala');
      var lbl = el('span', 'mg-cbox__code', p.code);
      btn.appendChild(lbl);
      btn.insertAdjacentHTML('beforeend', COPY_SVG);
      var l1el = txt.querySelector('.mg-cbox__l1');
      var l1txt = p.l1;
      fitWords(l1el, p.l1);
      var last = 0;
      var doCopy = function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var now = Date.now();
        if (now - last < 600) return; // pointerup + click çift tetiklenmesin
        last = now;
        copyText(p.code);
        btn.classList.remove('is-copied');
        void btn.offsetWidth; // animasyon her tıkta yeniden oynasın
        btn.classList.add('is-copied');
        node.classList.add('mg-cbox--copied');
        lbl.textContent = 'KOPYALANDI';
        if (l1el) l1el.textContent = 'Kod kopyalandı ✓';
        btn.setAttribute('aria-label', 'Kod kopyalandı');
        if (cfg('toast', true)) toast(p.code);
        node._mgPause = now + 2600;
        node.classList.add('mg-cbox--paused');
        clearTimeout(node._mgPauseT);
        node._mgPauseT = setTimeout(function () {
          if (!node._mgHover) node.classList.remove('mg-cbox--paused');
        }, 2600);
        clearTimeout(btn._mgT);
        btn._mgT = setTimeout(function () {
          btn.classList.remove('is-copied');
          node.classList.remove('mg-cbox--copied');
          lbl.textContent = p.code;
          if (l1el) fitWords(l1el, l1txt);
          btn.setAttribute('aria-label', p.code + ' kodunu kopyala');
        }, 2400);
      };
      // Slider/kart tıklama dinleyicileri dokunuşu yutmasın
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
        btn.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      btn.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'mouse') doCopy(e);
      });
      btn.addEventListener('click', doCopy);
      row.appendChild(btn);
      txt.appendChild(row);
      inner.appendChild(txt);
    } else if (p.kind === 'taksit') {
      var n = parseInt(p.big, 10);
      var pe = priceEl(node);
      var total = pe ? moneyOf(pe.textContent) : 0;
      // Sepet indirimi varsa taksit sepet fiyatından hesaplanır
      var srate = sepetRateFor(node);
      if (total > 0 && srate > 0) total = Math.round(total * (100 - srate)) / 100;
      if (n > 1 && total > 0 && cfg('taksitTutar', true)) {
        var tl2 = el('span', 'mg-cbox__l2');
        tl2.appendChild(el('b', 'mg-cbox__price mg-cbox__price--taksit', n + ' × ' + fmtTL(Math.round((total / n) * 100) / 100)));
        txt.appendChild(tl2);
        // Dar kartta "Vade Farksız 3 Taksit" sığmazsa "Vade Farksız" kalır (3× solda yazıyor)
        var tl1 = txt.querySelector('.mg-cbox__l1');
        requestAnimationFrame(function () {
          if (tl1 && tl1.scrollWidth > tl1.clientWidth + 1) {
            var short = clean(p.l1.replace(/\s*\d+\s*Taksit/i, ''));
            if (short) tl1.textContent = short;
          }
        });
      }
      inner.appendChild(txt);
      // Ürün sayfasında varyant değişince fiyat değişir: taksiti yeniden hesapla
      if (pe && !node._mgPriceWatch && !node.closest('.product-block') && 'MutationObserver' in window) {
        node._mgPriceWatch = true;
        new MutationObserver(function () {
          if (node.getAttribute('data-mg-kind') === 'taksit') render(node, inner, it);
        }).observe(pe, { childList: true, subtree: true, characterData: true });
      }
    } else {
      inner.appendChild(txt);
    }
  }

  function readItems(node) {
    try {
      var a = JSON.parse(node.getAttribute('data-efx-tags') || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return x && clean(x.text); }) : [];
    } catch (e) {
      return [];
    }
  }

  // ---- Dönüş: tek ortak saat. Her kutu kendi süresini sayar; üzerine gelince,
  // kod kopyalanınca ya da sekme arka plandayken durur. Alttaki çubuk kaç kampanya
  // olduğunu ve sıradakine ne kadar kaldığını gösterir.
  var rotors = [];
  var lastTick = 0;
  function tick() {
    var now = Date.now();
    var dt = lastTick ? Math.min(now - lastTick, 250) : 0;
    lastTick = now;
    if (document.hidden) return;
    var period = Math.max(1000, cfg('period', 1.5) * 1000);
    for (var k = rotors.length - 1; k >= 0; k--) {
      var r = rotors[k];
      if (!r.node.isConnected) { rotors.splice(k, 1); continue; }
      if (r.fading || r.bar) continue;
      if (r.node._mgHover || now < (r.node._mgPause || 0)) continue;
      r.elapsed += dt;
      if (r.fill) r.fill.style.transform = 'scaleX(' + Math.min(1, r.elapsed / period) + ')';
      if (r.elapsed >= period) advance(r);
    }
  }
  // Çubuk CSS animasyonuyla akar (akıcı, takılmaz); aktif bölüm dolunca
  // animationend sıradaki kampanyaya geçirir. Duraklatma: .mg-cbox--paused
  function paintBar(r) {
    if (!r.bar) return;
    var segs = r.bar.children;
    var period = Math.max(1000, cfg('period', 1.5) * 1000);
    r.bar.style.setProperty('--mg-period', period + 'ms');
    for (var k = 0; k < segs.length; k++) {
      var f = segs[k].firstChild;
      f.classList.remove('is-active');
      f.classList.toggle('is-done', k < r.i);
    }
    var cur = segs[r.i] ? segs[r.i].firstChild : null;
    if (cur) {
      void cur.offsetWidth; // animasyon baştan başlasın
      cur.classList.add('is-active');
    }
    r.fill = null;
  }
  // Geçişte kutu hiç boş kalmaz: yeni kampanya anında yazılır, kısa bir kayma
  // ile belirir (eski içerik söndürülüp beklenmez).
  function advance(r) {
    r.i = (r.i + 1) % r.items.length;
    r.elapsed = 0;
    render(r.node, r.inner, r.items[r.i]);
    r.inner.classList.remove('is-entering');
    void r.inner.offsetWidth;
    r.inner.classList.add('is-entering');
    paintBar(r);
  }
  setInterval(tick, 80);

  function stop(node) {
    for (var k = rotors.length - 1; k >= 0; k--) if (rotors[k].node === node) rotors.splice(k, 1);
    var old = node.querySelector(':scope > .mg-cbox__bar');
    if (old) old.remove();
    node.classList.remove('mg-cbox--has-bar');
  }

  function setup(node, allowCreate) {
    if (!node || node.nodeType !== 1) return;
    // Sayfa ayrıştırılırken iç kap henüz gelmemiş olabilir; gelince yeniden çağrılır
    if (!node.querySelector('.custom-tag-inner') && allowCreate !== true) return;
    var raw = node.getAttribute('data-efx-tags') || '';
    if (node.dataset.mgInit === '1' && node._mgRaw === raw) return;

    var items = readItems(node);
    // Eski rotator bu düğümü atlasın
    node.dataset.efxInit = '1';
    if (!items.length) {
      node.style.display = 'none';
      return;
    }
    node.style.display = '';
    node._mgRaw = raw;
    node.dataset.mgInit = '1';
    node.classList.add('mg-cbox');
    if (node.matches(VIT_SEL)) {
      // Section'ın kendi etiket renkleri ID seçicisiyle !important yazılı; kutu
      // section'ın yazı rengini alsın diye zemin/renk/çerçeve satır içi ezilir.
      // Marka Vitrini kartı da koleksiyon kartındaki kutuyla aynı görünsün
      node.classList.add('custom-tag-rotator--below', 'mg-cbox--bs');
      // Koleksiyon kartındaki gibi kutusuz (K8): zemin şeffaf, çerçeve yok
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('color', '#141414', 'important');
      node.style.setProperty('border', '0', 'important');
    }

    var inner = node.querySelector('.custom-tag-inner');
    if (!inner) {
      inner = el('div', 'custom-tag-inner');
      node.appendChild(inner);
    }

    node._mgItems = items;
    render(node, inner, items[0]);
    applySepetPrice(node.closest('.efx-bs__card') || node.closest('.product-block'), sepetFromItems(items));
    stop(node);
    watchAlign(node);

    if (!node._mgHoverBound) {
      node._mgHoverBound = true;
      node.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') { node._mgHover = true; node.classList.add('mg-cbox--paused'); }
      });
      node.addEventListener('pointerleave', function () {
        node._mgHover = false;
        if (Date.now() >= (node._mgPause || 0)) node.classList.remove('mg-cbox--paused');
      });
    }

    if (items.length > 1) {
      var r = { node: node, inner: inner, items: items, i: 0, elapsed: 0, bar: null, fill: null };
      if (cfg('bar', true)) {
        var bar = el('span', 'mg-cbox__bar');
        bar.setAttribute('aria-hidden', 'true');
        for (var k = 0; k < items.length; k++) {
          var seg = el('span', 'mg-cbox__seg');
          seg.appendChild(el('span', 'mg-cbox__fill'));
          bar.appendChild(seg);
        }
        node.appendChild(bar);
        node.classList.add('mg-cbox--has-bar');
        r.bar = bar;
        bar.addEventListener('animationend', function (e) {
          if (e.target.classList.contains('is-active') && !r.fading) advance(r);
        });
        paintBar(r);
      }
      rotors.push(r);
    }
  }

  // ---- Ürün sayfası: discount-badge.liquid output:'html' -> sabit .custom-tag kutuları
  var PDP_SEL = '.custom-tag:not(.custom-tag-rotator)';
  function setupPdp(node, force) {
    if (!node || node.nodeType !== 1 || node.dataset.mgPdp === '1') return;
    if (!cfg('pdp', true)) return;
    if (node.closest('.custom-tag-rotator')) return;
    // Sayfa ayrıştırılırken metin yarım gelmiş olabilir: kardeşi geldiyse kapanmıştır
    if (!force && document.readyState === 'loading' && !node.nextSibling) return;
    var text = clean(node.textContent);
    if (!text) return;
    node.dataset.mgPdp = '1';
    node.setAttribute('data-mg-text', text);
    node.classList.add('mg-cbox', 'mg-cbox--pdp');
    node.textContent = '';
    var inner = el('div', 'custom-tag-inner');
    node.appendChild(inner);
    render(node, inner, { text: text });
    var pp = parse({ text: text });
    if (pp.kind === 'sepet') applySepetPrice(pdpScope(node), rateOf(pp));
  }

  function teardown(node) {
    stop(node);
    if (node && node.dataset) {
      delete node.dataset.mgInit;
      node._mgRaw = null;
    }
  }

  // ---- Hiza yedeği: CSS zinciri bir yerde kırılırsa (tema/uygulama kuralı),
  // kutuyu kartın altına JS ile iter. CSS çalışıyorsa fark 0 çıkar, dokunmaz.
  var alignT = null;
  function alignAll() {
    if (!cfg('align', true)) return;
    var nodes = document.querySelectorAll(SEL + '.mg-cbox');
    var jobs = [];
    nodes.forEach(function (n) {
      if (n._mgExtra) { n.style.removeProperty('margin-top'); n._mgExtra = 0; }
    });
    nodes.forEach(function (n) {
      var pb = n.closest('.product-block');
      var det = n.parentElement;
      if (!pb || !det || !n.offsetParent) return;
      var diff = Math.round(pb.getBoundingClientRect().bottom - det.getBoundingClientRect().bottom);
      if (diff > 1) jobs.push([n, diff, parseFloat(getComputedStyle(n).marginTop) || 0]);
    });
    jobs.forEach(function (j) {
      j[0]._mgExtra = j[1];
      j[0].style.setProperty('margin-top', (j[2] + j[1]) + 'px', 'important');
    });
  }
  function scheduleAlign() {
    clearTimeout(alignT);
    alignT = setTimeout(function () { requestAnimationFrame(alignAll); }, 120);
  }
  var alignRO = 'ResizeObserver' in window ? new ResizeObserver(scheduleAlign) : null;
  function watchAlign(node) {
    var pb = node.closest && node.closest('.product-block');
    if (pb && alignRO && !pb._mgRO) { pb._mgRO = true; alignRO.observe(pb); }
    scheduleAlign();
  }
  window.addEventListener('resize', scheduleAlign);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleAlign);

  function scan(root) {
    (root || document).querySelectorAll(ROT_SEL).forEach(function (x) { setup(x, true); });
    (root || document).querySelectorAll(PDP_SEL).forEach(function (x) { setupPdp(x, true); });
  }

  var mo = new MutationObserver(function (muts) {
    for (var k = 0; k < muts.length; k++) {
      var m = muts[k];
      if (m.type === 'attributes') {
        if (m.target.matches && m.target.matches(ROT_SEL)) setup(m.target, true);
        continue;
      }
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(ROT_SEL)) setup(n);
        else if (n.classList.contains('custom-tag-inner') && n.parentElement && n.parentElement.matches(ROT_SEL)) setup(n.parentElement);
        if (n.querySelectorAll) n.querySelectorAll(ROT_SEL).forEach(function (x) { setup(x); });
        if (n.matches(PDP_SEL)) setupPdp(n);
        if (n.previousElementSibling && n.previousElementSibling.matches(PDP_SEL)) setupPdp(n.previousElementSibling);
        if (n.querySelectorAll) n.querySelectorAll(PDP_SEL).forEach(function (x) { setupPdp(x); });
      });
      m.removedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(ROT_SEL)) teardown(n);
        if (n.querySelectorAll) n.querySelectorAll(ROT_SEL).forEach(teardown);
      });
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-efx-tags']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  window.addEventListener('load', function () { scan(); });
  window.mgCboxInit = scan;
})();

/* =========================================================================
   Milagron · Ürün kartı: renk noktaları ve tek satır beden çipleri
   - .mg-sw[data-c] renk adını Tema ayarları > Swatches listesinden (window.MG_SW)
     renge çevirir; "#a#b" iki renkli ise yarım yarım boyar.
   - .mg-row--beden satırı tek satıra sığdırılır, sığmayanlar "+n" olur.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgCard) return;
  window.__mgCard = true;

  var MAP = null;
  function norm(s) {
    return String(s || '').toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim();
  }
  function map() {
    if (MAP) return MAP;
    MAP = {};
    String(window.MG_SW || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var k = norm(line.slice(0, i));
      var v = line.slice(i + 1).trim();
      if (k && v && !(k in MAP)) MAP[k] = v;
    });
    return MAP;
  }
  function bg(v) {
    var cols = v.match(/#[0-9a-f]{3,8}/gi);
    if (!cols) return /^https?:|^\/\//.test(v) ? 'center/cover url("' + v + '")' : '';
    if (cols.length === 1) return cols[0];
    var step = 100 / cols.length, parts = [];
    cols.forEach(function (c, k) { parts.push(c + ' ' + (k * step) + '% ' + ((k + 1) * step) + '%'); });
    if (cols.length >= 4) return 'conic-gradient(' + parts.join(',') + ')';
    return 'linear-gradient(135deg,' + parts.join(',') + ')';
  }
  function paintSw(root) {
    (root || document).querySelectorAll('.mg-sw[data-c]:not([data-mg-sw])').forEach(function (e) {
      e.setAttribute('data-mg-sw', '1');
      var v = mgcResolve(e.getAttribute('data-c'), map());
      if (!v) { var hx0 = e.getAttribute('data-hex'); if (hx0 && /^#[0-9a-f]{3,8}$/i.test(hx0)) v = hx0; }
      if (v && mgcBg(v)) e.style.background = mgcBg(v);
      else {
        // Rengi tanımlı olmayan renk kartta gösterilmez; satırda hiç renk kalmazsa satır da gizlenir
        e.classList.add('mg-sw-x');
        var row = e.closest('.mg-row--renk');
        if (row && !row.querySelector('.mg-sw:not(.mg-sw-x)')) row.classList.add('mg-row-x');
      }
    });
  }

  function fitRow(row) {
    if (!row.isConnected || !row.offsetWidth) return;
    var chips = [].slice.call(row.querySelectorAll('.mg-chip:not(.is-more)'));
    if (!chips.length) return;
    var more = row.querySelector('.mg-chip.is-more');
    chips.forEach(function (c) { c.classList.remove('is-hidden'); });
    if (more) more.remove();
    var right = row.getBoundingClientRect().right;
    if (chips[chips.length - 1].getBoundingClientRect().right <= right + 0.5) return;
    var hidden = 0;
    for (var k = chips.length - 1; k > 0; k--) {
      chips[k].classList.add('is-hidden');
      hidden++;
      if (chips[k - 1].getBoundingClientRect().right <= right - 34) break;
    }
    var m = document.createElement('span');
    m.className = 'mg-chip is-more';
    m.textContent = '+' + hidden;
    row.appendChild(m);
  }
  function fitAll(root) {
    (root || document).querySelectorAll('.mg-row--beden').forEach(fitRow);
  }

  var t;
  function run(root) {
    paintSw(root);
    fitAll(root);
  }
  function later() {
    clearTimeout(t);
    t = setTimeout(function () { requestAnimationFrame(function () { run(); }); }, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  // Filtre / sonsuz kaydırma ile gelen yeni kartlar
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          if (a[j].nodeType === 1 && (a[j].matches('.mg-row,product-block') || a[j].querySelector && a[j].querySelector('.mg-row'))) { later(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* =========================================================================
   Milagron · Görsel çubukları: ürünün görsel sayısı kadar çubuk, kaydırınca
   aktif görselin çubuğu siyah olur (tema yalnız 2 nokta yönetiyordu).
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgDots) return;
  window.__mgDots = true;
  function sync(cont) {
    var pb = cont.closest('product-block') || cont;
    var imgs = [].slice.call(cont.querySelectorAll('.product-block__image'));
    var dots = [].slice.call(pb.querySelectorAll('.product-block__image-dot:not(.product-block__image-dot--more)'));
    if (!imgs.length || !dots.length) return;
    var i = -1;
    for (var k = 0; k < imgs.length; k++) if (imgs[k].classList.contains('product-block__image--active')) { i = k; break; }
    if (i < 0) i = 0;
    if (i > dots.length - 1) i = dots.length - 1;
    dots.forEach(function (d, k) {
      var on = k === i;
      if (d.classList.contains('product-block__image-dot--active') !== on) d.classList.toggle('product-block__image-dot--active', on);
    });
  }
  function bind(root) {
    (root || document).querySelectorAll('product-block .image-cont:not([data-mg-dots])').forEach(function (c) {
      if (!c.querySelector('.product-block__image-dots')) return;
      c.setAttribute('data-mg-dots', '1');
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = requestAnimationFrame(function () { t = null; sync(c); });
      }).observe(c, { attributes: true, attributeFilter: ['class'], subtree: true });
      sync(c);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  window.addEventListener('load', function () { bind(); });
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var a = ms[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.matches('product-block') || (n.querySelector && n.querySelector('product-block')))) { bind(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Sepet sayısı 0 iken rozet gizli; ürün eklenince görünür (üst sepet ve alt menü) */
(function () {
  'use strict';
  if (window.__mgZero) return;
  window.__mgZero = true;
  var SEL = '.m-float-cart__badge, .m-bnav__badge, .cart-link .cart-count, .cart-link__count';
  function check() {
    document.querySelectorAll(SEL).forEach(function (b) {
      var t = (b.textContent || '').replace(/\s+/g, '');
      var z = t === '' || t === '0';
      if (b.classList.contains('mg-zero') !== z) b.classList.toggle('mg-zero', z);
    });
  }
  var q = 0;
  function later() { if (!q) q = requestAnimationFrame(function () { q = 0; check(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('load', check);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target, e = t.nodeType === 1 ? t : t.parentElement;
      if (e && (e.closest(SEL) || (e.querySelector && e.querySelector(SEL)))) { later(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* =========================================================================
   Milagron · Mobil arama ekranı: sağda arama oku, son aramalar, boş marka gizleme
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgSearch) return;
  window.__mgSearch = true;
  var KEY = 'mg_recent_searches';
  function load() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function store(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {} }
  function save(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim();
    if (!q || q.length > 60) return;
    var a = load().filter(function (x) { return x.toLocaleLowerCase('tr-TR') !== q.toLocaleLowerCase('tr-TR'); });
    a.unshift(q);
    store(a);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Arama sonuç sayfasına gelindiyse aranan kelimeyi kaydet
  try {
    if (/^\/search/.test(location.pathname)) {
      var q0 = new URLSearchParams(location.search).get('q');
      if (q0) save(q0);
    }
  } catch (e) {}
  function go(q) {
    q = String(q || '').trim();
    if (!q) return;
    save(q);
    location.href = '/search?q=' + encodeURIComponent(q);
  }
  function renderRecent(def) {
    var box = def.querySelector('.mg-s-recent');
    var a = load();
    if (!box) {
      box = document.createElement('div');
      box.className = 'mg-s-recent';
      var left = def.querySelector(':scope > .mg-s-left');
      if (left) left.insertBefore(box, left.firstChild); else def.insertBefore(box, def.firstChild);
    }
    var html = a.length ? '<div class="mg-s-h">Son aramalar<button type="button" data-mg-s-clear>Temizle</button></div><div class="mg-s-chips">' +
      a.map(function (q) { return '<a class="mg-s-chip" href="/search?q=' + encodeURIComponent(q) + '"><span>' + esc(q) + '</span><i data-mg-s-del="' + esc(q) + '" aria-label="Sil">×</i></a>'; }).join('') + '</div>' : '';
    if (box.innerHTML !== html) box.innerHTML = html;
    box.style.display = a.length ? '' : 'none';
  }
  function setup() {
    var ov = document.querySelector('.efx-search-overlay');
    if (!ov) return;
    var hd = ov.querySelector('.efx-drawer-header');
    if (hd && !hd.querySelector('.mg-s-go')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mg-s-go';
      b.setAttribute('aria-label', 'Ara');
      hd.appendChild(b);
    }
    ov.querySelectorAll('.efx-pop-vendors li').forEach(function (li) {
      var empty = !(li.textContent || '').trim();
      if (li.classList.contains('mg-s-empty') !== empty) li.classList.toggle('mg-s-empty', empty);
    });
    ov.querySelectorAll('.efx-see-all-top').forEach(function (a) {
      var t = 'Tüm sonuçları gör';
      if (a.firstChild && a.firstChild.nodeType === 3 && a.firstChild.textContent.trim() !== t) a.firstChild.textContent = t + ' ';
    });
    var def = ov.querySelector('.efx-search-default');
    if (def) renderRecent(def);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var del = t.closest('[data-mg-s-del]');
    if (del) {
      e.preventDefault(); e.stopPropagation();
      var v = del.getAttribute('data-mg-s-del');
      store(load().filter(function (x) { return x !== v; }));
      setup();
      return;
    }
    if (t.closest('[data-mg-s-clear]')) { e.preventDefault(); store([]); setup(); return; }
    if (t.closest('.efx-search-overlay .mg-s-go')) {
      e.preventDefault();
      var inp = document.querySelector('.efx-search-overlay .efx-drawer-input');
      go(inp && inp.value);
      return;
    }
    var all = t.closest('.efx-search-overlay .efx-see-all-top');
    if (all) { var i2 = document.querySelector('.efx-search-overlay .efx-drawer-input'); if (i2) save(i2.value); }
    var chip = t.closest('.efx-search-overlay .mg-s-chip, .efx-search-overlay .efx-pop-queries a');
    if (chip) save(chip.textContent.replace('×', ''));
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.classList && (t.classList.contains('efx-drawer-input') || t.classList.contains('efx-main-search__input'))) save(t.value);
  }, true);
  var q = 0;
  function later() { if (!q) q = requestAnimationFrame(function () { q = 0; setup(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var tg = ms[i].target;
      var el = tg.nodeType === 1 ? tg : tg.parentElement;
      if (el && el.closest && el.closest('.mg-s-recent')) continue;
      if (el && (el.closest('.efx-search-overlay') || (ms[i].addedNodes[0] && ms[i].addedNodes[0].nodeType === 1 && ms[i].addedNodes[0].classList && ms[i].addedNodes[0].classList.contains('efx-search-overlay')))) { later(); return; }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* =========================================================================
   Arama kartlarında sepette fiyatı: ürünün kampanya etiketleri
   /products/<handle>?view=mgsp ile alınır, "Sepette %NN" varsa fiyat yazılır.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgSearchSp) return;
  window.__mgSearchSp = true;
  var CK = 'mg_sp_cache_v1', cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CK) || '{}') || {}; } catch (e) {}
  function keep() { try { sessionStorage.setItem(CK, JSON.stringify(cache)); } catch (e) {} }
  var MONEY = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/;
  function money(t) { var m = MONEY.exec(String(t || '')); return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : 0; }
  function fmt(v) { try { return v.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; } catch (e) { return v.toFixed(2).replace('.', ',') + ' TL'; } }
  function rateFrom(txt) {
    var items = [];
    try { items = JSON.parse(txt); } catch (e) { items = [{ text: txt }]; }
    if (!Array.isArray(items)) items = [items];
    for (var i = 0; i < items.length; i++) {
      var m = /Sepette\s*%\s*(\d+(?:[.,]\d+)?)/i.exec((items[i] && items[i].text) || '');
      if (m) return parseFloat(m[1].replace(',', '.'));
    }
    return 0;
  }
  // Koleksiyon kartıyla aynı fiyat merdiveni: çizili ilk fiyat → İndirim → Sepette
  function apply(card, rate) {
    card.setAttribute('data-mg-sp', rate ? String(rate) : '0');
    var pr = card.querySelector('.efx-card-price'), fin = card.querySelector('.efx-card-final');
    if (!pr || !fin || pr.querySelector('.mg-wp')) return;
    var cur = money(fin.textContent), cmpEl = pr.querySelector('.efx-card-compare'), cmp = cmpEl ? money(cmpEl.textContent) : 0;
    if (!cur) return;
    if (!(cmp > cur)) cmp = 0;
    var h = '';
    if (cmp) h += '<s>' + fmt(cmp) + '</s>'; else if (rate) h += '<s>' + fmt(cur) + '</s>';
    if (cmp) h += '<span class="mg-wp__r mg-wp__ind' + (rate ? ' mg-wp__x' : '') + '"><i>İndirim</i><b>' + fmt(cur) + '</b></span>';
    else if (!rate) h += '<span class="mg-wp__r"><b>' + fmt(cur) + '</b></span>';
    if (rate) h += '<span class="mg-wp__r mg-wp__sp"><i>Sepette</i><b>' + fmt(Math.round(cur * (100 - rate)) / 100) + '</b></span>';
    pr.classList.add('mg-ssp-on');
    pr.innerHTML = '<div class="mg-wp">' + h + '</div>';
    var bd = card.querySelector('.efx-discount-badge');
    if (bd && cmp) bd.textContent = '%' + Math.round((1 - cur / cmp) * 100);
    fitPrice(pr);
  }
  // Uzun fiyatlar kart genişliğine sığsın: taşan satırın puntosunu kademeli küçült
  function fitPrice(pr) {
    var w = pr.querySelector('.mg-wp'); if (!w || !w.clientWidth) return;
    w.querySelectorAll('.mg-wp__r, s').forEach(function (r) {
      var el = r.tagName === 'S' ? r : r.querySelector('b'); if (!el) return;
      el.style.removeProperty('font-size');
      var fs = parseFloat(getComputedStyle(el).fontSize), min = r.tagName === 'S' ? 10 : 11, n = 0;
      while (r.scrollWidth > w.clientWidth + 0.5 && fs > min && n++ < 12) { fs -= 0.5; el.style.setProperty('font-size', fs + 'px', 'important'); }
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('.efx-search-overlay .efx-card-price.mg-ssp-on').forEach(fitPrice); });
  var inflight = {};
  function handleOf(a) { var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function run() {
    document.querySelectorAll('.efx-search-overlay .efx-card:not([data-mg-sp])').forEach(function (card) {
      if (!card.offsetParent) return;
      var h = handleOf(card);
      if (!h) { card.setAttribute('data-mg-sp', '0'); return; }
      if (h in cache) { apply(card, cache[h]); return; }
      if (inflight[h]) return;
      inflight[h] = fetch('/products/' + encodeURIComponent(h) + '?view=mgsp', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : '[]'; })
        .then(function (t) { cache[h] = rateFrom(t); keep(); })
        .catch(function () { cache[h] = 0; })
        .then(function () {
          delete inflight[h];
          document.querySelectorAll('.efx-search-overlay .efx-card:not([data-mg-sp])').forEach(function (c) { if (handleOf(c) === h) apply(c, cache[h]); });
        });
    });
  }
  var q = 0;
  function later() { if (!q) q = setTimeout(function () { q = 0; run(); }, 150); }
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target, e = t.nodeType === 1 ? t : t.parentElement;
      if (e && e.closest && e.closest('.efx-search-overlay') && !e.closest('.mg-wp')) { later(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
;(function(){function m(){var n=document.querySelector('.m-bottom-nav');if(!n)return;var r=n.getBoundingClientRect();var h=Math.max(0,Math.round(window.innerHeight-r.top));if(!h||getComputedStyle(n).display=='none')return;document.documentElement.style.setProperty('--mg-nav-h',h+'px');}
m();window.addEventListener('resize',m);window.addEventListener('load',m);if(window.visualViewport)visualViewport.addEventListener('resize',m);document.addEventListener('focusin',function(){setTimeout(m,350)});document.addEventListener('input',function(){setTimeout(m,50)});})();
;(function(){function d(){var c=document.querySelector('.slideshow-pagination .page-btn__fg-circle');var p=document.querySelector('.slideshow-pagination');if(!c||!p)return;var s=getComputedStyle(c).animationDuration;if(s&&s!=='0s')p.style.setProperty('--mg-ss-dur',s);}
if(document.readyState!=='loading')d();else document.addEventListener('DOMContentLoaded',d);window.addEventListener('load',d);})();
/* Milagron · Growave misafir favori kutusu: alttan açılan sade kart, iOS yakınlaştırması yok (16px giriş) */
;(function(){
  var CSS = [
    /* Tüm Growave pencereleri (seçenek değiştir, yeni liste, yeniden adlandır, sil...) */
    '.gw-modal-dialog{font-family:inherit!important;color:#141414!important}',
    '.gw-modal-dialog .gw-text{color:#141414!important;font-family:inherit!important}',
    '.gw-modal-dialog .gw-modal-dialog__header{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;padding:6px 0 12px!important;min-height:0!important}',
    '.gw-modal-dialog .gw-modal-dialog__header .gw-text{font-size:17px!important;font-weight:800!important;line-height:1.3!important}',
    '.gw-modal-dialog .gw-modal-dialog__close-btn{flex:none!important;width:32px!important;height:32px!important;border-radius:50%!important;background:#141414!important;color:#fff!important;display:flex!important;align-items:center!important;justify-content:center!important}',
    '.gw-modal-dialog .gw-modal-dialog__close-btn svg{width:18px!important;height:18px!important}',
    '.gw-modal-dialog .gw-modal-dialog__header:not(:has(.gw-text)){position:relative!important;height:0!important;min-height:0!important;padding:0!important;margin:0!important}',
    '.gw-modal-dialog .gw-modal-dialog__header:not(:has(.gw-text)) .gw-modal-dialog__close-btn{position:absolute!important;right:-6px!important;top:-10px!important;z-index:2}',
    '.gw-modal-dialog .gw-modal-dialog__close-btn:focus,.gw-modal-dialog .gw-modal-dialog__close-btn:focus-visible{outline:none!important;box-shadow:none!important}',
    '.gw-modal-dialog .gw-modal-dialog__body{padding-top:6px!important}',
    '.gw-modal-dialog .gw-form-layout-item__header{padding-right:44px}',
    '.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn){display:flex!important;flex-wrap:wrap!important;gap:6px 8px!important;width:100%!important;justify-content:space-between!important}',
    '.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn) > .gw-btn--mode-primary{order:-1!important;flex:1 1 100%!important;height:50px!important}',
    '.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn) > .gw-btn:not(.gw-btn--mode-primary){flex:1 1 0!important;height:42px!important;background:#f3f3f2!important;border:0!important;box-shadow:none!important;border-radius:10px!important;padding:0 8px!important}',
    '.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn) > .gw-btn:not(.gw-btn--mode-primary) .gw-text{font-size:13px!important;font-weight:700!important;white-space:nowrap!important;color:#141414!important}',
    '.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn) > .gw-btn--mode-tertiary .gw-text,.gw-modal-dialog :has(> .gw-btn ~ .gw-btn ~ .gw-btn) > .gw-btn--mode-link .gw-text{color:#c8262c!important}',
    '.gw-wl-create-modal__content li{border:0!important;box-shadow:none!important;padding:0!important;background:transparent!important;position:relative!important}',
    '.gw-wl-create-modal__content .mg-cm-media{aspect-ratio:auto!important;height:auto!important;min-height:0!important;padding:0!important;border:0!important;box-shadow:none!important;background:transparent!important;border-radius:10px!important;overflow:hidden!important}',
    '.gw-wl-create-modal__content li img{width:100%!important;aspect-ratio:2/3!important;height:auto!important;object-fit:cover!important;display:block!important;border-radius:10px!important;border:0!important}',
    '.gw-wl-create-modal__content li h3,.gw-wl-create-modal__content li .gw-text--heading-md{font-size:12.5px!important;font-weight:600!important;line-height:1.35!important;margin-top:6px!important}',
    '.gw-wl-create-modal__content li .gw-text--tone-tertiary,.gw-wl-create-modal__content li .gw-text--body-lg{font-size:11px!important;color:#8a8a8a!important}',
    '.gw-wl-create-modal__content li .money,.gw-wl-create-modal__content li .gw-price .gw-text{font-size:13px!important;font-weight:800!important}',
    '.gw-wl-create-modal__content .mg-sel{width:28px!important;height:28px!important;border-radius:50%!important;background:#fff!important;border:0!important;box-shadow:0 0 0 1.5px #141414,0 2px 8px rgba(0,0,0,.18)!important;top:8px!important;right:8px!important;left:auto!important;opacity:1!important}',
    '.gw-wl-create-modal__content .mg-sel>*{opacity:0!important}',
    '.gw-wl-create-modal__content .mg-sel::after{content:"+";position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font:600 18px/1 Montserrat,sans-serif;color:#141414}',
    '.gw-wl-create-modal__content li:has(input:checked) .mg-sel,.gw-wl-create-modal__content .mg-sel[aria-checked=true],.gw-wl-create-modal__content .mg-sel.mg-on{background:#141414!important}',
    '.gw-wl-create-modal__content li:has(input:checked) .mg-sel::after,.gw-wl-create-modal__content .mg-sel[aria-checked=true]::after,.gw-wl-create-modal__content .mg-sel.mg-on::after{content:"✓";color:#fff;font-size:14px}',
    '.gw-wl-create-modal__content ul{gap:16px 10px!important}',
    '.gw-modal-dialog :not(.mg-dc):has(> .gw-btn + .gw-btn):not(:has(> .gw-btn ~ .gw-btn ~ .gw-btn)){display:flex!important;gap:8px!important;width:100%!important;flex-wrap:nowrap!important}',
    '.gw-modal-dialog :not(.mg-dc):has(> .gw-btn + .gw-btn):not(:has(> .gw-btn ~ .gw-btn ~ .gw-btn)) > .gw-btn{flex:1 1 0!important;min-width:0!important;margin:0!important;height:50px!important;border-radius:12px!important}',
    '.gw-modal-dialog :not(.mg-dc):has(> .gw-btn + .gw-btn):not(:has(> .gw-btn ~ .gw-btn ~ .gw-btn)) > .gw-btn--mode-primary{flex:1.6 1 0!important}',
    '.gw-modal-dialog :not(.mg-dc):has(> .gw-btn + .gw-btn):not(:has(> .gw-btn ~ .gw-btn ~ .gw-btn)) > .gw-btn:not(.gw-btn--mode-primary){background:#f3f3f2!important;border:0!important;box-shadow:none!important;color:#141414!important}',
    '.gw-modal-dialog .gw-btn-group.mg-ft3.mg-ft3.mg-ft3{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important;width:100%!important;flex-wrap:nowrap!important}',
    '.gw-modal-dialog .mg-ft3 .mg-dc.mg-dc.mg-dc.mg-dc.mg-dc.mg-dc{display:contents!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn{margin:0!important;min-width:0!important;width:100%!important;height:48px!important;border-radius:12px!important;padding:0 10px!important;flex:none!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn .gw-text{white-space:nowrap!important;font-size:14px!important;font-weight:700!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-primary{grid-column:1/-1!important;order:-1!important;height:52px!important;background:#141414!important;color:#fff!important;border:0!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-primary .gw-text{color:#fff!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-secondary,.gw-modal-dialog .mg-ft3 .gw-btn--mode-tertiary{background:#f3f3f2!important;border:0!important;box-shadow:none!important;order:1!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-secondary .gw-text{color:#141414!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-tertiary{order:2!important}',
    '.gw-modal-dialog .mg-ft3 .gw-btn--mode-tertiary .gw-text{color:#c8262c!important}',
    '.gw-modal-dialog .gw-modal-dialog__header.gw-modal-dialog__header:not(:has(.gw-text)){position:sticky!important;top:0!important;z-index:8!important;height:40px!important;min-height:40px!important;margin:-14px 0 0!important;padding:0!important;background:#fff!important;display:flex!important;align-items:center!important;justify-content:space-between!important}',
    '.gw-modal-dialog:has(.gw-wl-create-modal__content) .gw-modal-dialog__header:not(:has(.gw-text))::before{content:"Yeni liste";font-size:17px;font-weight:800;color:#141414}',
    '.gw-modal-dialog .gw-modal-dialog__header.gw-modal-dialog__header:not(:has(.gw-text)) .gw-modal-dialog__close-btn{position:static!important;margin-left:auto!important;width:32px!important;height:32px!important}',
    '.gw-modal-dialog:has(.gw-modal-dialog__header:not(:has(.gw-text))) .gw-modal-dialog__body{padding-top:0!important;margin-top:0!important}',
    '.gw-modal-dialog .gw-modal-dialog__close-btn{background:#141414!important;opacity:1!important;color:#fff!important}',
    '.gw-modal-dialog .gw-modal-dialog__header:has(.gw-text){position:sticky!important;top:0!important;z-index:8!important;background:#fff!important}',
    '.gw-modal-dialog .gw-product-thumbnail:not(.gw-product-thumbnail--size-fluid){width:46px!important;height:auto!important;aspect-ratio:2/3!important;border:0!important;box-shadow:none!important;border-radius:8px!important;overflow:hidden!important;padding:0!important;background:#f3f3f2!important;flex:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail:not(.gw-product-thumbnail--size-fluid) .gw-product-thumbnail__content,.gw-modal-dialog .gw-product-thumbnail:not(.gw-product-thumbnail--size-fluid) .gw-image{width:100%!important;height:100%!important;aspect-ratio:auto!important;border:0!important;box-shadow:none!important;padding:0!important;border-radius:0!important}',
    '.gw-modal-dialog .gw-product-thumbnail:not(.gw-product-thumbnail--size-fluid) img{width:100%!important;height:100%!important;object-fit:cover!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-row{display:flex!important;align-items:center!important;gap:14px!important;padding:12px 0!important;border-bottom:1px solid #ececea!important;background:transparent!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-th{flex:none!important;width:52px!important;min-width:52px!important;height:auto!important;aspect-ratio:2/3!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:9px!important;overflow:hidden!important;padding:0!important;margin:0!important;background:#f3f3f2!important;position:relative!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-th *{width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;aspect-ratio:auto!important;border:0!important;box-shadow:none!important;border-radius:0!important;padding:0!important;margin:0!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-th img{object-fit:cover!important;display:block!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-row:has(.mg-sv-hb[aria-pressed=true],.mg-sv-hb[aria-checked=true],.mg-sv-hb path[fill=currentColor]) .mg-sv-th::after{content:"";position:absolute;inset:0;border-radius:9px;box-shadow:inset 0 0 0 2px #141414;pointer-events:none}',
    '.gw-modal-dialog.mg-sv .mg-sv-hb{flex:none!important;width:40px!important;height:40px!important;min-width:40px!important;padding:0!important;margin:0 0 0 auto!important;border-radius:50%!important;border:0!important;background:#fff!important;color:#141414!important;box-shadow:0 2px 8px rgba(0,0,0,.12),0 0 0 1px rgba(0,0,0,.03)!important;display:inline-flex!important;align-items:center!important;justify-content:center!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-hb svg{width:20px!important;height:20px!important;color:#141414!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-row .gw-text--heading-md,.gw-modal-dialog.mg-sv .mg-sv-row h3,.gw-modal-dialog.mg-sv .mg-sv-row h4{font-size:15px!important;font-weight:800!important;color:#141414!important}',
    '.gw-modal-dialog.mg-sv .mg-sv-row .gw-text--body-md,.gw-modal-dialog.mg-sv .mg-sv-row .gw-text--body-lg,.gw-modal-dialog.mg-sv .mg-sv-row .gw-text--tone-tertiary{font-size:12.5px!important;color:#6b6b6b!important;font-weight:500!important}',
    '.gw-modal-dialog.mg-sv .gw-modal-dialog__header .gw-text{font-size:18px!important;font-weight:800!important}',
    '.gw-modal-dialog .gw-wl-add-to-wishlist-modal__list{gap:0!important;padding:0!important;margin:0!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item{list-style:none!important;border-bottom:1px solid #ececea!important;background:transparent!important;margin:0!important;padding:0!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__btn{display:flex!important;align-items:center!important;gap:14px!important;width:100%!important;padding:12px 4px 12px 0!important;box-sizing:border-box!important;background:transparent!important;border:0!important;box-shadow:none!important;text-align:left!important;-webkit-tap-highlight-color:transparent}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__btn:hover,.gw-wl-select-wishlist-item__btn:focus,.gw-wl-select-wishlist-item__btn[aria-pressed=true]{background:transparent!important;outline:0!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__thumbnail{position:relative!important;flex:none!important;width:52px!important;min-width:52px!important;height:auto!important;aspect-ratio:2/3!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:9px!important;overflow:hidden!important;padding:0!important;margin:0!important;background:#f3f3f2!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__thumbnail .gw-image,.gw-wl-select-wishlist-item__thumbnail img{width:100%!important;height:100%!important;aspect-ratio:auto!important;border:0!important;border-radius:0!important;box-shadow:none!important;object-fit:cover!important;display:block!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__btn[aria-pressed=true] .gw-wl-select-wishlist-item__thumbnail::after{content:"";position:absolute;inset:0;border-radius:9px;box-shadow:inset 0 0 0 2px #141414;pointer-events:none}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__info{flex:1 1 auto!important;min-width:0!important;gap:2px!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__info .gw-text--heading-md{font-size:15px!important;font-weight:800!important;color:#141414!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__info .gw-text--body-md{font-size:12.5px!important;color:#6b6b6b!important;font-weight:500!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__trailing{flex:none!important;width:40px!important;height:40px!important;margin-left:auto!important;border-radius:50%!important;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22%3E%3Cpath d=%22M11.4807 6.1862L12 6.68455L12.5193 6.1862C13.447 5.29596 14.7044 4.75 16.0909 4.75C18.9402 4.75 21.25 7.0598 21.25 9.90909C21.25 12.5032 19.8356 14.5608 18.0169 16.1398C16.1975 17.7194 14.0516 18.7475 12.7931 19.2652C12.2797 19.4764 11.7203 19.4764 11.2069 19.2652C9.9484 18.7475 7.80251 17.7194 5.98314 16.1398C4.16437 14.5609 2.75 12.5032 2.75 9.90909C2.75 7.0598 5.0598 4.75 7.90909 4.75C9.2956 4.75 10.553 5.29596 11.4807 6.1862Z%22 fill=%22none%22 stroke=%22%23141414%22 stroke-width=%221.5%22/%3E%3C/svg%3E") center/20px 20px no-repeat!important;box-shadow:0 2px 8px rgba(0,0,0,.12),0 0 0 1px rgba(0,0,0,.03)!important;display:block!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__trailing>*{display:none!important}',
    '.gw-modal-dialog .gw-wl-select-wishlist-item__btn[aria-pressed=true] .gw-wl-select-wishlist-item__trailing{background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22%3E%3Cpath d=%22M11.4807 6.1862L12 6.68455L12.5193 6.1862C13.447 5.29596 14.7044 4.75 16.0909 4.75C18.9402 4.75 21.25 7.0598 21.25 9.90909C21.25 12.5032 19.8356 14.5608 18.0169 16.1398C16.1975 17.7194 14.0516 18.7475 12.7931 19.2652C12.2797 19.4764 11.7203 19.4764 11.2069 19.2652C9.9484 18.7475 7.80251 17.7194 5.98314 16.1398C4.16437 14.5609 2.75 12.5032 2.75 9.90909C2.75 7.0598 5.0598 4.75 7.90909 4.75C9.2956 4.75 10.553 5.29596 11.4807 6.1862Z%22 fill=%22%23141414%22 stroke=%22%23141414%22 stroke-width=%221.5%22/%3E%3C/svg%3E")!important}',
    '.gw-modal-dialog .mg-newrow{border-bottom:0!important}',
    '.gw-modal-dialog .mg-newrow__btn{display:flex!important;align-items:center!important;gap:14px!important;width:100%!important;padding:12px 0!important;background:transparent!important;border:0!important;cursor:pointer;font:inherit!important;color:#141414!important;text-align:left!important;-webkit-tap-highlight-color:transparent}',
    '.gw-modal-dialog .mg-newrow__box{flex:none;width:52px;aspect-ratio:2/3;box-sizing:border-box;border:1.5px dashed #c9c9c6;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:400;line-height:1;color:#141414}',
    '.gw-modal-dialog .mg-newrow__txt{font-size:15px;font-weight:800;color:#141414}',
    '.gw-modal-dialog:has(.gw-wl-edit-modal__body) .gw-modal-dialog__header:not(:has(.gw-text))::before,.gw-wl-edit-modal__dialog .gw-modal-dialog__header:not(:has(.gw-text))::before{content:"Listeyi düzenle";font-size:17px;font-weight:800;color:#141414}',
    '@media (min-width:768px){.gw-modal:has(.gw-wl-create-modal__dialog),.gw-modal:has(.gw-wl-edit-modal__dialog){display:flex!important;align-items:center!important;justify-content:center!important}.gw-modal__content:has(.gw-wl-create-modal__dialog){width:min(820px,92vw)!important;max-width:none!important;margin:0 auto!important}.gw-modal-dialog.gw-wl-create-modal__dialog{width:min(820px,92vw)!important;max-width:none!important;max-height:86vh!important;padding:22px 28px 22px!important;border-radius:18px!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-create-modal__dialog .gw-wl-form-product-grid{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:22px 14px!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-create-modal__dialog .gw-modal-dialog__header{height:48px!important;min-height:48px!important;margin:0 0 6px!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-create-modal__dialog .gw-modal-dialog__header::before{font-size:20px!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-create-modal__dialog form:has(.gw-wl-form-product-grid) .gw-inline-stack:last-child{justify-content:flex-end!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-create-modal__dialog form:has(.gw-wl-form-product-grid) .gw-inline-stack:last-child>.gw-btn{flex:0 0 200px!important}.gw-modal__content:has(.gw-wl-edit-modal__dialog){width:min(460px,92vw)!important;max-width:none!important;margin:0 auto!important}.gw-modal-dialog.gw-wl-edit-modal__dialog{width:min(460px,92vw)!important;max-width:none!important;padding:22px 24px!important;border-radius:18px!important}.gw-modal-dialog.gw-modal-dialog.gw-wl-edit-modal__dialog .gw-modal-dialog__header{height:44px!important;min-height:44px!important;margin:0 0 6px!important}}',
    '.gw-modal-dialog .gw-wl-form-product-card .gw-price.mg-wp-hide{display:none!important}',
    '.gw-modal-dialog .mg-wp{display:flex;flex-direction:column;gap:1px;margin-top:3px;font-family:inherit}',
    '.gw-modal-dialog .mg-wp s{font-size:12px;font-weight:600;color:#6f6f6f;text-decoration:line-through;text-decoration-thickness:1.5px;white-space:nowrap}',
    '.gw-modal-dialog .mg-wp .mg-wp__r{display:flex;align-items:baseline;gap:5px;white-space:nowrap;min-width:0}',
    '.gw-modal-dialog .mg-wp .mg-wp__r i{font-style:normal;font-size:10.5px;font-weight:700}',
    '.gw-modal-dialog .mg-wp .mg-wp__r b{font-size:14px;font-weight:800;color:#141414}',
    '.gw-modal-dialog .mg-wp .mg-wp__ind i,.gw-modal-dialog .mg-wp .mg-wp__ind b{color:#C8102E}',
    '.gw-modal-dialog .mg-wp .mg-wp__ind.mg-wp__x b{text-decoration:line-through;text-decoration-thickness:1.5px;font-size:12.5px;font-weight:700}',
    '.gw-modal-dialog .mg-wp .mg-wp__sp i,.gw-modal-dialog .mg-wp .mg-wp__sp b{color:#0B7A43}',
    '.gw-modal-dialog .mg-wp .mg-wp__sp b{font-size:15px}',
    '@keyframes mgHeartPop{0%{transform:scale(.4)}60%{transform:scale(1.25)}100%{transform:scale(1)}}',
    '.gw-modal-dialog .gw-wl-form-product-grid{display:grid!important;grid-template-columns:1fr 1fr!important;gap:18px 10px!important}',
    '.gw-modal-dialog .gw-wl-form-product-card{min-width:0!important;display:flex!important;flex-direction:column!important;gap:3px!important;cursor:pointer}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox{position:relative!important;display:block!important;width:100%!important;border:0!important;box-shadow:none!important;padding:0!important;background:transparent!important;border-radius:10px!important;cursor:pointer!important;-webkit-tap-highlight-color:transparent}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__input{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;pointer-events:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__thumbnail-wrapper,.gw-modal-dialog .gw-product-thumbnail-checkbox .gw-product-thumbnail,.gw-modal-dialog .gw-product-thumbnail-checkbox .gw-product-thumbnail__content,.gw-modal-dialog .gw-product-thumbnail-checkbox .gw-image{display:block!important;width:100%!important;height:auto!important;aspect-ratio:2/3!important;border:0!important;box-shadow:none!important;padding:0!important;margin:0!important;background:#f3f3f2!important;border-radius:10px!important;overflow:hidden!important;max-width:none!important;max-height:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox img{width:100%!important;height:100%!important;object-fit:cover!important;display:block!important;border:0!important;border-radius:0!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__thumbnail-wrapper{outline:0!important;box-shadow:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__indicator{position:absolute!important;top:8px!important;right:8px!important;left:auto!important;bottom:auto!important;z-index:3!important;width:34px!important;height:34px!important;border-radius:50%!important;background:#fff!important;border:0!important;box-shadow:0 2px 8px rgba(0,0,0,.12),0 0 0 1px rgba(0,0,0,.03)!important;display:flex!important;align-items:center!important;justify-content:center!important;opacity:1!important;transform:none!important;transition:background .15s}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__indicator::before{display:none!important;content:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__indicator>*{display:none!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__indicator::after{content:""!important;position:static!important;display:block!important;width:18px!important;height:18px!important;background:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22%3E%3Cpath d=%22M11.4807 6.1862L12 6.68455L12.5193 6.1862C13.447 5.29596 14.7044 4.75 16.0909 4.75C18.9402 4.75 21.25 7.0598 21.25 9.90909C21.25 12.5032 19.8356 14.5608 18.0169 16.1398C16.1975 17.7194 14.0516 18.7475 12.7931 19.2652C12.2797 19.4764 11.7203 19.4764 11.2069 19.2652C9.9484 18.7475 7.80251 17.7194 5.98314 16.1398C4.16437 14.5609 2.75 12.5032 2.75 9.90909C2.75 7.0598 5.0598 4.75 7.90909 4.75C9.2956 4.75 10.553 5.29596 11.4807 6.1862Z%22 fill=%22none%22 stroke=%22%23141414%22 stroke-width=%221.5%22/%3E%3C/svg%3E") center/contain no-repeat!important;border:0!important;transform:none!important;margin:0!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__input:checked~.gw-product-thumbnail-checkbox__indicator{background:#fff!important;box-shadow:0 2px 8px rgba(0,0,0,.12),0 0 0 1px rgba(0,0,0,.03)!important}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__input:checked~.gw-product-thumbnail-checkbox__indicator::after{background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22%3E%3Cpath d=%22M11.4807 6.1862L12 6.68455L12.5193 6.1862C13.447 5.29596 14.7044 4.75 16.0909 4.75C18.9402 4.75 21.25 7.0598 21.25 9.90909C21.25 12.5032 19.8356 14.5608 18.0169 16.1398C16.1975 17.7194 14.0516 18.7475 12.7931 19.2652C12.2797 19.4764 11.7203 19.4764 11.2069 19.2652C9.9484 18.7475 7.80251 17.7194 5.98314 16.1398C4.16437 14.5609 2.75 12.5032 2.75 9.90909C2.75 7.0598 5.0598 4.75 7.90909 4.75C9.2956 4.75 10.553 5.29596 11.4807 6.1862Z%22 fill=%22%23141414%22 stroke=%22%23141414%22 stroke-width=%221.5%22/%3E%3C/svg%3E")!important;animation:mgHeartPop .28s ease-out}',
    '.gw-modal-dialog .gw-product-thumbnail-checkbox__input:focus-visible~.gw-product-thumbnail-checkbox__indicator{outline:none!important}',
    '.gw-modal-dialog .gw-wl-form-product-card>p.gw-text--heading-md{font-size:12.5px!important;font-weight:600!important;line-height:1.35!important;margin-top:6px!important}',
    '.gw-modal-dialog .gw-wl-form-product-card>p.gw-text--body-lg{font-size:11.5px!important;color:#8a8a8a!important;line-height:1.3!important}',
    '.gw-modal-dialog .gw-wl-form-product-card .gw-price .gw-text,.gw-modal-dialog .gw-wl-form-product-card .money{font-size:13px!important;font-weight:800!important}',
    '.gw-modal-dialog form:has(.gw-wl-form-product-grid)>*>.gw-inline-stack:last-child,.gw-modal-dialog form:has(.gw-wl-form-product-grid)>.gw-inline-stack:last-child{position:sticky!important;bottom:0!important;z-index:5!important;background:#fff!important;padding:12px 0 calc(10px + env(safe-area-inset-bottom))!important;margin-top:4px!important;box-shadow:0 -10px 14px -6px rgba(255,255,255,.95)!important;gap:8px!important}',
    '.gw-modal-dialog form:has(.gw-wl-form-product-grid) .gw-inline-stack:last-child>.gw-btn{flex:1 1 0!important;height:48px!important}',
    '.gw-modal-dialog form:has(.gw-wl-form-product-grid) .gw-inline-stack:last-child>.gw-btn--mode-primary{flex:2 1 0!important}',
    '.gw-modal-dialog .gw-form-field-label .gw-text{font-size:13px!important;font-weight:700!important}',
    '.gw-modal-dialog input:not([type=checkbox]):not([type=radio]), .gw-modal-dialog select, .gw-modal-dialog .gw-select__trigger button, .gw-modal-dialog .gw-input__input{font-size:16px!important;min-height:50px!important;border-radius:12px!important;border:1px solid #e3e3e0!important;background:#f6f6f5!important;box-shadow:none!important;color:#141414!important;padding:0 14px!important;width:100%!important;box-sizing:border-box!important}',
    '.gw-modal-dialog .gw-input{border:0!important;box-shadow:none!important;background:transparent!important;padding:0!important}',
    '.gw-modal-dialog img{border-radius:10px!important}',
    '.gw-modal-dialog .gw-btn-group{display:flex!important;gap:10px!important;width:100%!important}',
    '.gw-modal-dialog .gw-btn{height:50px!important;border-radius:12px!important;flex:1 1 0!important;min-width:0!important;justify-content:center!important;box-shadow:none!important}',
    '.gw-modal-dialog .gw-btn--mode-primary{flex:2 1 0!important;background:#141414!important;color:#fff!important;border:0!important}',
    '.gw-modal-dialog .gw-btn--mode-primary .gw-text{color:#fff!important}',
    '.gw-modal-dialog .gw-btn--mode-primary[disabled],.gw-modal-dialog .gw-btn--mode-primary[aria-disabled=true]{background:#e8e8e6!important}',
    '.gw-modal-dialog .gw-btn--mode-primary[disabled] .gw-text,.gw-modal-dialog .gw-btn--mode-primary[aria-disabled=true] .gw-text{color:#8a8a8a!important}',
    '.gw-modal-dialog .gw-btn--mode-secondary{background:#fff!important;border:1px solid #e3e3e0!important;color:#141414!important}',
    '.gw-modal-dialog .gw-btn .gw-text{font-size:14px!important;font-weight:700!important}',
    '@media (max-width:767.98px){',
    '.gw-modal{display:flex!important;flex-direction:column!important;justify-content:flex-end!important;align-items:stretch!important;padding:0!important}',
    '.gw-modal .gw-modal__content{position:relative!important;inset:auto!important;transform:none!important;padding:0!important;margin:0!important;width:100%!important;max-width:none!important;height:auto!important;min-height:0!important;display:block!important;flex:none!important}',
    '.gw-modal-dialog{width:100%!important;max-width:none!important;margin:0!important;border-radius:20px 20px 0 0!important;box-shadow:0 -8px 30px rgba(0,0,0,.12)!important;padding:8px 18px calc(18px + env(safe-area-inset-bottom))!important;animation:mgUp .25s ease-out}',
    '.gw-modal-dialog::before{content:"";display:block;width:38px;height:4px;border-radius:2px;background:#dcdcd9;margin:2px auto 8px}',
    '}',
    '@media (max-width:767.98px){',
    '.gw-wl-save-guest-item-modal{display:flex!important;flex-direction:column!important;justify-content:flex-end!important;align-items:stretch!important;padding:0!important}','.gw-wl-save-guest-item-modal .gw-modal__content{position:relative!important;inset:auto!important;transform:none!important;padding:0!important;margin:0 0 0 0!important;width:100%!important;max-width:none!important;height:auto!important;min-height:0!important;display:block!important;flex:none!important}',
    '.gw-wl-save-guest-item-modal-dialog{width:100%!important;max-width:none!important;margin:0!important;border-radius:20px 20px 0 0!important;box-shadow:0 -8px 30px rgba(0,0,0,.12)!important;padding:8px 18px calc(18px + env(safe-area-inset-bottom))!important;animation:mgUp .25s ease-out}',
    '.gw-wl-save-guest-item-modal-dialog::before{content:"";display:block;width:38px;height:4px;border-radius:2px;background:#dcdcd9;margin:2px auto 6px}',
    '}',
    '@keyframes mgUp{from{transform:translateY(40px);opacity:.4}to{transform:none;opacity:1}}',
    '.gw-wl-save-guest-item-modal-dialog{font-family:inherit!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__header{min-height:0!important;padding:0!important;margin:0!important;position:relative!important;height:0!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__close-btn{position:absolute!important;right:-6px!important;top:-6px!important;width:32px!important;height:32px!important;border-radius:50%!important;background:#141414!important;color:#fff!important;display:flex!important;align-items:center!important;justify-content:center!important;z-index:2}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__close-btn svg{width:18px!important;height:18px!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__body{padding:0!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-form-layout-item__header .gw-text{font-size:16px!important;font-weight:700!important;line-height:1.35!important;color:#141414!important;padding:18px 0 4px 0!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-form-layout-item__header .gw-text::after{content:"Favorilerin kaybolmasın, istediğin zaman geri dön.";display:block;font-size:12.5px;font-weight:500;color:#8a8a8a;margin-top:4px}',
    '.gw-wl-save-guest-item-modal-dialog .gw-input{padding:0!important;margin:0!important;width:100%!important;border:0!important;box-shadow:none!important;background:transparent!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-input__input{font-size:16px!important;height:50px!important;border-radius:12px!important;border:1px solid #e3e3e0!important;background:#f6f6f5!important;padding:0 14px!important;box-shadow:none!important;outline:none!important;width:100%!important;box-sizing:border-box!important;-webkit-appearance:none}',
    '.gw-wl-save-guest-item-modal-dialog .gw-input__input:focus{border-color:#141414!important;background:#fff!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-checkbox{align-items:center!important;gap:10px!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-checkbox .gw-text{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;font-size:13px!important;color:#5c5c5c!important;line-height:1.35!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-btn-group{display:flex!important;gap:10px!important;width:100%!important;margin-top:4px!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-btn{height:50px!important;border-radius:12px!important;flex:1 1 0!important;min-width:0!important;justify-content:center!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-btn--mode-primary{flex:2 1 0!important;background:#141414!important;color:#fff!important;border:0!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-btn--mode-secondary{background:#fff!important;border:1px solid #e3e3e0!important;color:#141414!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-btn .gw-text{font-size:14px!important;font-weight:700!important}'
  ].join('');
  var TXT = [
    [/istek listenize kaydetmek/i, 'Ürünü favorilerinize kaydetmek için e\u2011postanızı girin'],
    [/Fiyat düşüşü ve stok yenileme/i, 'Fiyat düşünce ve stoğa girince haber ver.'],
    [/^\s*Ürün seçeneklerini değiştirme\s*$/i, 'Seçenekleri değiştir'],
    [/^\s*Favorites\s*$/, 'Favoriler'],
    [/^\s*Yeni bir liste ekle\s*$/i, 'Yeni liste'],
    [/^\s*Şuna göre sırala:\s*$/i, 'Sırala:'],
    [/^\s*Yinelenen\s*$/i, 'Listeyi çoğalt'],
    [/^\s*Favorilerim adı\s*$/i, 'Liste adı'],
    [/^\s*Listeyi sil\s*$/i, 'Listeyi sil'],
    [/^\s*Satışta\s*$/i, 'İndirimde'],
    [/^\s*Sepette Göster\s*$/i, 'Sepete git'],
    [/^\s*Yakın zamanda eklendi\s*$/i, 'Son eklenen'],
    [/^\s*İsim A-Z\s*$/i, 'İsim: A → Z'],
    [/^\s*İsim Z-A\s*$/i, 'İsim: Z → A'],
    [/^\s*Fiyat Yüksek-Düşük\s*$/i, 'Fiyat: Yüksekten düşüğe'],
    [/^\s*Fiyat Düşük-Yüksek\s*$/i, 'Fiyat: Düşükten yükseğe'],
    [/^\s*(\d+)\s*öğe(ler)?\s*$/i, function(t){ return t.replace(/öğe(ler)?/i,'ürün'); }],
    [/^\s*(Stokta geri|Tekrar stokta|Back in stock)\s*$/i, 'Yeniden stokta'],
    [/^\s*Son görüntülenen ürünleri ekle/i, function(t){ var m=/\((\d+)\)/.exec(t); return 'Son baktığın ürünlerden ekle' + (m ? ' (' + m[1] + ')' : ''); }],
    [/^\s*Liste adını girin\s*$/i, 'Örn. Doğum günü listem']
  ];
  function relabel(root){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      for (var i = 0; i < TXT.length; i++) if (TXT[i][0].test(n.nodeValue)) { var nv = typeof TXT[i][1] === 'function' ? TXT[i][1](n.nodeValue) : TXT[i][1]; if (n.nodeValue !== nv) n.nodeValue = nv; }
    }
  }
  function relabelPh(root){ (root.querySelectorAll ? root.querySelectorAll('input[placeholder]') : []).forEach(function(i){ if(/Liste adını girin/i.test(i.placeholder)) i.placeholder='Örn. Doğum günü listem'; }); }
  function tagSave(root){
    return; if(!root.querySelectorAll) return;
    root.querySelectorAll('.gw-modal-dialog').forEach(function(d){
      if(d.querySelector('.gw-wl-create-modal__content')) return;
      d.querySelectorAll('svg.gw-wl-icon').forEach(function(svg){
        var btn=svg.closest('button'); if(!btn || btn.classList.contains('mg-sv-hb')) return;
        var row=btn.parentElement; while(row && row!==d && !row.querySelector('img')) row=row.parentElement;
        if(!row || row===d) return;
        var img=row.querySelector('img'); if(!img) return;
        btn.classList.add('mg-sv-hb'); row.classList.add('mg-sv-row'); d.classList.add('mg-sv');
        var th=img.closest('.gw-image')||img; th=th.parentElement&&th.parentElement!==row&&!th.parentElement.contains(btn)?th.parentElement:th;
        while(th.parentElement && th.parentElement!==row && !th.parentElement.contains(btn) && !/\S/.test((th.parentElement.textContent||'').replace(th.textContent,''))) th=th.parentElement;
        th.classList.add('mg-sv-th');
      });
    });
  }
  function mgGwReq(){ if(window.__mgReq) return window.__mgReq; try{ window.gwWebpackGlobal.rspackChunkstorefront_spa.push([['mgreq'+Date.now()],{},function(r){ window.__mgReq=r; }]); }catch(x){} return window.__mgReq; }
  function mgOpenCreate(){
    try{
      var r=mgGwReq(); if(!r) return false;
      var mm=r(85514).kL.resolve(r(82211).UO), T=r(60380);
      if(!mm || !T || !T.uc || typeof mm.openModal!=='function') return false;
      var pid=window.__mgLastPid, vid=window.__mgLastVid;
      mm.openModal(T.uc, true);
      window.__mgPendingAdd = pid ? { productId: pid, variantId: vid || null, handle: window.__mgLastHandle || null } : null;
      return true;
    }catch(x){ return false; }
  }
  document.addEventListener('click',function(e){ var b=e.target.closest&&e.target.closest('.gw-toggle-wishlist-product-card-button, .gw-toggle-wishlist-product-button, [class*="gw-wl-add-to-wishlist"] button'); if(!b) return; var c=b.closest('[data-product-id]'); if(c){ window.__mgLastPid=Number(c.getAttribute('data-product-id'))||null; var hl=c.querySelector('a[href*="/products/"]'); window.__mgLastHandle=hl?(/\/products\/([^/?#]+)/.exec(hl.getAttribute('href'))||[])[1]||null:null; var v=c.querySelector('[data-variant-id]'); window.__mgLastVid=v?Number(v.getAttribute('data-variant-id'))||null:null; } else { var m=document.querySelector('form[action*="/cart/add"] [name="id"]'); var pm=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product; if(pm){ window.__mgLastPid=pm.id; window.__mgLastVid=m?Number(m.value):null; window.__mgLastHandle=(/\/products\/([^/?#]+)/.exec(location.pathname)||[])[1]||null; } } },true);
  function addNewRow(root){
    if(!root.querySelectorAll) return;
    root.querySelectorAll('.gw-wl-add-to-wishlist-modal__list').forEach(function(ul){
      if(ul.querySelector('.mg-newrow')) return;
      var li=document.createElement('li'); li.className='gw-wl-select-wishlist-item mg-newrow';
      li.innerHTML='<button type="button" class="mg-newrow__btn"><span class="mg-newrow__box" aria-hidden="true">+</span><span class="mg-newrow__txt">Yeni liste oluştur</span></button>';
      li.querySelector('button').addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); if(mgOpenCreate()) return; try{ sessionStorage.setItem('mgNewList','1'); }catch(x){} location.href='/pages/favorilerim'; });
      ul.appendChild(li);
    });
  }
  function fixFooter(root){
    if(!root.querySelectorAll) return;
    root.querySelectorAll('.gw-modal-dialog').forEach(function(d){
      var bs=[].slice.call(d.querySelectorAll('.gw-btn')).filter(function(b){ return !b.closest('.gw-modal-dialog__header') && !b.classList.contains('gw-modal-dialog__close-btn') && b.offsetParent!==null; });
      if(bs.length!==3 || !bs.some(function(b){return b.classList.contains('gw-btn--mode-primary');})) return;
      var a=bs[0].parentElement; while(a && !(a.contains(bs[1]) && a.contains(bs[2]))) a=a.parentElement;
      if(!a || a.classList.contains('mg-ft3')) return;
      a.classList.add('mg-ft3');
      bs.forEach(function(b){ for(var e=b.parentElement; e && e!==a; e=e.parentElement) e.classList.add('mg-dc'); b.classList.add(b.classList.contains('gw-btn--mode-primary')?'mg-ft-p':(/sil|delete/i.test(b.textContent)?'mg-ft-d':'mg-ft-s')); });
    });
  }
  function tagCreate(root){
    if(!root.querySelectorAll) return;
    root.querySelectorAll('.gw-wl-create-modal__content li').forEach(function(li){
      var img = li.querySelector('img'); if(!img) return;
      for (var e = img.parentElement; e && e !== li; e = e.parentElement) { if (e.querySelector('h3, .gw-text--heading-md')) break; e.classList.add('mg-cm-media'); }
      if (!li.querySelector('.mg-sel')) {
        var c = [].slice.call(li.querySelectorAll('*')).filter(function(e){ var cs = getComputedStyle(e); return cs.position === 'absolute' && e.offsetWidth > 10 && e.offsetWidth <= 44 && !e.closest('.mg-sel'); })[0];
        if (c) { c.classList.add('mg-sel'); li.addEventListener('click', function(){ setTimeout(function(){ var i = li.querySelector('input'); var on = i ? i.checked : (c.getAttribute('aria-checked') === 'true' || li.getAttribute('aria-selected') === 'true'); if (!i && c.getAttribute('aria-checked') === null) on = !c.classList.contains('mg-on'); c.classList.toggle('mg-on', !!on); }, 30); }); }
      }
    });
  }
  function fixFav(root){ (root.querySelectorAll ? root.querySelectorAll('input[name="title"]') : []).forEach(function(i){ if(i.value==='Favorites' && !i._mgFav){ i._mgFav=1; i.value='Favoriler'; i.dispatchEvent(new Event('input',{bubbles:true})); } }); }
  function inject(root){
    if(!root) return;
    if(root !== document.head) { relabel(root); relabelPh(root); fixFav(root); tagCreate(root); fixFooter(root); tagSave(root); addNewRow(root); if(window.mgWpEnrich) window.mgWpEnrich(root); }
    if(root.__mgGw) return; root.__mgGw=1;
    var s=document.createElement('style'); s.textContent=CSS; root.appendChild(s);
    if(root !== document.head) new MutationObserver(function(){ relabel(root); relabelPh(root); fixFav(root); tagCreate(root); fixFooter(root); tagSave(root); addNewRow(root); if(window.mgWpEnrich) window.mgWpEnrich(root); }).observe(root,{childList:true,subtree:true,characterData:true});
  }
  function scan(){
    inject(document.head);
    document.querySelectorAll('[class*="gw-"]').forEach(function(e){ if(e.shadowRoot) inject(e.shadowRoot); });
    document.querySelectorAll('.gw-wl-page-placeholder, .gw-modal').forEach(function(r){ relabel(r); relabelPh(r); fixFav(r); tagCreate(r); fixFooter(r); tagSave(r); addNewRow(r); if(window.mgWpEnrich) window.mgWpEnrich(r); });
  }
  var pend=false; new MutationObserver(function(){ if(pend) return; pend=true; requestAnimationFrame(function(){ pend=false; scan(); }); }).observe(document.documentElement,{childList:true,subtree:true});
  scan();
})();
/* Arama "Tüm sonuçları gör": iOS'ta kapsayıcı kayınca alt menünün hemen üstüne gerçek ölçüyle oturt */
;(function(){
  function fix(){
    if (!window.matchMedia('(max-width:767.98px)').matches) return;
    var b = document.querySelector('.efx-search-overlay.is-open .efx-search-results:not([hidden]) .efx-see-all-top');
    if (!b || !b.offsetParent) return;
    var nav = document.querySelector('.m-bottom-nav'), nr = nav && nav.getBoundingClientRect();
    var want = (nr && nr.height && getComputedStyle(nav).display !== 'none') ? nr.top - 12 : window.innerHeight - 12;
    var r = b.getBoundingClientRect(), cur = parseFloat(getComputedStyle(b).bottom) || 0, d = r.bottom - want;
    if (Math.abs(d) > 0.5) b.style.setProperty('bottom', (cur + d) + 'px', 'important');
  }
  setInterval(fix, 400);
  ['resize','scroll','input','focusin','focusout'].forEach(function(ev){ window.addEventListener(ev, function(){ requestAnimationFrame(fix); }, true); });
  if (window.visualViewport) visualViewport.addEventListener('resize', fix);
})();
/* Favorilerim: boş listeye "Alışverişe başla" butonu ve metin */
;(function(){
  function run(){
    var e = document.querySelector('.gw-wl-page-placeholder .gw-empty-state');
    if (!e || e.querySelector('.mg-wl-go')) return;
    var ps = e.querySelectorAll('p');
    if (ps[0]) ps[0].textContent = 'Favorilerin henüz boş';
    if (ps[1]) ps[1].textContent = 'Beğendiğin ürünlerdeki kalbe dokun, hepsi burada seni beklesin.';
    var a = document.createElement('a'); a.className = 'mg-wl-go'; a.href = '/collections/all'; a.textContent = 'Alışverişe başla';
    e.appendChild(a);
  }
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
/* Marka Vitrini bedenleri tek satır: sığmayanlar "+n" */
;(function(){
  function fit(row){
    if (!row.offsetWidth) return;
    var ch=[].slice.call(row.querySelectorAll('.bedenOptionEFX:not(.mg-more)'));
    ch.forEach(function(c){c.classList.remove('mg-hid')});
    var m=row.querySelector('.mg-more'); if(m) m.remove();
    var R=row.getBoundingClientRect().right;
    if(!ch.length || ch[ch.length-1].getBoundingClientRect().right<=R+0.5) return;
    var n=0;
    for(var k=ch.length-1;k>0;k--){ ch[k].classList.add('mg-hid'); n++; if(ch[k-1].getBoundingClientRect().right<=R-34) break; }
    m=document.createElement('span'); m.className='bedenOptionEFX mg-more'; m.textContent='+'+n; row.appendChild(m);
  }
  function all(){ document.querySelectorAll('.efx-bs__sizes').forEach(fit); }
  window.addEventListener('load', all); window.addEventListener('resize', all);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  setTimeout(all, 1200);
})();
/* Favorilerim kartı: "36, Siyah, Unisex" satırı koleksiyondaki gibi küçük kutucuklara */
;(function(){
  function run(){
    document.querySelectorAll('.gw-wl-page-placeholder .gw-wl-product-card__content > .gw-block-stack > p.gw-text--tone-tertiary:not(.mg-wl-hid)').forEach(function(p){
      var parts = p.textContent.split(',').map(function(s){return s.trim();}).filter(function(s){return s && !/^(kadın|erkek|unisex|çocuk|default title)$/i.test(s);});
      p.classList.add('mg-wl-hid');
      var box = document.createElement('div'); box.className = 'mg-wl-opts';
      parts.forEach(function(t){ var s=document.createElement('span'); s.textContent=t; box.appendChild(s); });
      p.parentNode.insertBefore(box, p.nextSibling);
    });
  }
  new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Favoriler: paylaş = WhatsApp · Kopyala · Diğer (yan yana) */
;(function(){
  var WA='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';
  var LN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>';
  var SH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>';
  function item(box, n){ var it = box.querySelectorAll('.gw-wl-share__item')[n]; return it && (it.querySelector('button') || it); }
  // Paylaşım bağlantısı: Growave'in shareWishlists cevabından alınır, sayfa açılınca sessizce hazırlanır
  if (!window.__mgFetchPatched && window.fetch) {
    window.__mgFetchPatched = 1;
    var of = window.fetch;
    window.fetch = function(u){
      var pr = of.apply(this, arguments);
      try { if (/shareWishlists/.test(String(u && u.url || u))) pr.then(function(r){ return r.clone().json(); }).then(function(j){ if (j && j.shareWishlistsUrl) window.__mgShareUrl = String(j.shareWishlistsUrl).replace('/pages/shared-wishlists','/pages/paylasilan-favoriler'); }).catch(function(){}); } catch(x){}
      return pr;
    };
  }
  function prewarm(box){
    if (box._mgWarm) return; box._mgWarm = 1;
    try { var c = item(box, 0); c && c.click(); } catch(x){}
  }
  function grabUrl(box){ return window.__mgShareUrl || location.href; }
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.gw-wl-card-list')) {
      window.__mgShareUrl = null;
      setTimeout(function(){ document.querySelectorAll('.gw-wl-page-placeholder .gw-wl-share').forEach(function(b){ b._mgWarm = 0; prewarm(b); }); }, 900);
    }
  }, true);
  function build(){
    document.querySelectorAll('.gw-wl-page-placeholder .gw-wl-share').forEach(function(box){
      if (box.querySelector('.mg-share')) return;
      var d = document.createElement('div'); d.className = 'mg-share';
      d.innerHTML = '<button type="button" class="mg-sh-wa">'+WA+'<span>WhatsApp</span></button><button type="button" class="mg-sh-cp">'+LN+'<span>Kopyala</span></button><button type="button" class="mg-sh-more">'+SH+'<span>Diğer</span></button>';
      box.appendChild(d);
      setTimeout(function(){ prewarm(box); }, 800);
      d.addEventListener('click', function(e){
        var b = e.target.closest('button'); if (!b) return;
        if (b.classList.contains('mg-sh-wa')) {
          var link = grabUrl(box);
          var msg = 'Milagron\'daki favori listeme göz at 🤍\n' + link;
          window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
        }
        else if (b.classList.contains('mg-sh-cp')) {
          if (window.__mgShareUrl && navigator.clipboard) { navigator.clipboard.writeText(window.__mgShareUrl).catch(function(){ var c0 = item(box, 0); c0 && c0.click(); }); } else { var c = item(box, 0); c && c.click(); }
          var s = b.querySelector('span'); s.textContent = 'Kopyalandı'; b.classList.add('mg-ok'); setTimeout(function(){ s.textContent = 'Kopyala'; b.classList.remove('mg-ok'); }, 1800);
        } else {
          var u = grabUrl(box);
          if (navigator.share) navigator.share({ title: 'Favorilerim · Milagron', url: u }).catch(function(){});
          else { var c2 = item(box, 0); c2 && c2.click(); }
        }
      });
    });
  }
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(build, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  build();
})();

/* Milagron: "Yeni liste oluştur"dan gelindiyse yeni liste penceresini aç */
;(function(){var f;try{f=sessionStorage.getItem('mgNewList')}catch(e){}if(!f||!/\/pages\/(favorilerim|wishlist)/.test(location.pathname))return;try{sessionStorage.removeItem('mgNewList')}catch(e){}
var n=0,iv=setInterval(function(){var b=document.querySelector('.gw-wl-page-placeholder .gw-btn--mode-link');if(b){clearInterval(iv);setTimeout(function(){b.click()},300);}else if(++n>60)clearInterval(iv);},250);})();

/* Milagron: "Yeni liste oluştur" ile açılan listeye, kalbine basılan ürünü ekle */
;(function(){
  var of=window.fetch; if(!of || window.__mgCreatePatch) return; window.__mgCreatePatch=1;
  function addTo(wid){
    var pa=window.__mgPendingAdd; window.__mgPendingAdd=null; if(!pa||!wid) return;
    var go=function(vid){ try{ var r=window.__mgReq; if(!r) return; var Q=r(85514).kL.resolve(r(92639).a); var o=Q.addItem({productId:pa.productId, variantId:vid, wishlistId:wid}); if(o&&o.subscribe) o.subscribe({next:function(){}, error:function(){}}); }catch(x){} };
    if(pa.variantId) return go(pa.variantId);
    if(!pa.handle) return;
    of.call(window,'/products/'+pa.handle+'.js').then(function(r){return r.json()}).then(function(p){ var v=(p.variants||[]).filter(function(x){return x.available})[0]||(p.variants||[])[0]; if(v) go(v.id); }).catch(function(){});
  }
  window.fetch=function(u){
    var pr=of.apply(this,arguments);
    try{ if(window.__mgPendingAdd && /\/createWishlist(\?|$)/.test(String(u&&u.url||u))) pr.then(function(r){return r.clone().json()}).then(function(j){ var w=j&&(j.createdWishlist||j); addTo(w&&w.id); }).catch(function(){}); }catch(x){}
    return pr;
  };
})();

/* Milagron: Yeni liste penceresindeki ürünlerde koleksiyon kartı fiyatı (üstü çizili, İndirim, Sepette) */
;(function(){
  var MK='mg_pid_h_v1', map={};
  try{ map=JSON.parse(localStorage.getItem(MK)||'{}')||{}; }catch(e){}
  function save(){ try{ localStorage.setItem(MK, JSON.stringify(map)); }catch(e){} }
  function learn(){
    var ch=0;
    document.querySelectorAll('[data-product-id]').forEach(function(c){ var id=c.getAttribute('data-product-id'); if(!id||map[id]) return; var a=c.querySelector('a[href*="/products/"]'); var m=a&&/\/products\/([^/?#]+)/.exec(a.getAttribute('href')); if(m){ map[id]=decodeURIComponent(m[1]); ch=1; } });
    try{ var pm=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product; var hm=/\/products\/([^/?#]+)/.exec(location.pathname); if(pm&&hm&&!map[pm.id]){ map[pm.id]=decodeURIComponent(hm[1]); ch=1; } }catch(e){}
    if(ch) save();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',learn); else learn();
  setTimeout(learn,3000);
  var data={}, pend={};
  function money(c){ return (c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL'; }
  function rateFrom(txt){ var it=[]; try{ it=JSON.parse(txt); }catch(e){ it=[{text:txt}]; } if(!Array.isArray(it)) it=[it]; for(var i=0;i<it.length;i++){ var m=/Sepette\s*%\s*(\d+(?:[.,]\d+)?)/i.exec((it[i]&&it[i].text)||''); if(m) return parseFloat(m[1].replace(',','.')); } return 0; }
  function handleFor(pid,title){
    if(map[pid]) return Promise.resolve(map[pid]);
    return fetch('/search/suggest.json?q='+encodeURIComponent(title)+'&resources[type]=product&resources[limit]=10').then(function(r){return r.json()}).then(function(j){ var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[]; for(var i=0;i<ps.length;i++){ if(String(ps[i].id)===String(pid)){ map[pid]=ps[i].handle; save(); return ps[i].handle; } } return null; }).catch(function(){return null});
  }
  function load(pid,title){
    if(data[pid]||pend[pid]) return pend[pid]||Promise.resolve(data[pid]);
    pend[pid]=handleFor(pid,title).then(function(h){
      if(!h) return null;
      return Promise.all([fetch('/products/'+h+'.js').then(function(r){return r.json()}), fetch('/products/'+h+'?view=mgsp').then(function(r){return r.ok?r.text():'[]'}).catch(function(){return '[]'})])
        .then(function(a){ data[pid]={p:a[0], rate:rateFrom(a[1])}; return data[pid]; });
    }).catch(function(){return null});
    return pend[pid];
  }
  function render(card,d,vid){
    var gp=card.querySelector('.gw-price'); if(!gp||!d) return;
    var v=(d.p.variants||[]).filter(function(x){return String(x.id)===String(vid)})[0]||(d.p.variants||[])[0]; if(!v) return;
    var cur=v.price, cmp=v.compare_at_price&&v.compare_at_price>cur?v.compare_at_price:0, r=d.rate;
    var h='';
    if(cmp) h+='<s>'+money(cmp)+'</s>';
    else if(r) h+='<s>'+money(cur)+'</s>';
    if(cmp) h+='<span class="mg-wp__r mg-wp__ind'+(r?' mg-wp__x':'')+'"><i>İndirim</i><b>'+money(cur)+'</b></span>';
    else if(!r) h+='<span class="mg-wp__r"><b>'+money(cur)+'</b></span>';
    if(r) h+='<span class="mg-wp__r mg-wp__sp"><i>Sepette</i><b>'+money(Math.round(cur*(100-r)/100))+'</b></span>';
    var box=card.querySelector('.mg-wp'); if(!box){ box=document.createElement('div'); box.className='mg-wp'; gp.parentNode.insertBefore(box,gp.nextSibling); }
    box.innerHTML=h; gp.classList.add('mg-wp-hide');
  }
  window.mgWpEnrich=function(root){
    if(!root||!root.querySelectorAll) return;
    root.querySelectorAll('.gw-wl-form-product-card').forEach(function(card){
      var inp=card.querySelector('input.gw-product-thumbnail-checkbox__input'); if(!inp) return;
      var key=inp.value; if(card._mgWp===key) return; card._mgWp=key;
      var parts=String(key).split('-'), pid=parts[0], vid=parts[1];
      var t=card.querySelector('p.gw-text--heading-md'); var title=t?t.textContent.trim():'';
      load(pid,title).then(function(d){ if(d) render(card,d,vid); });
    });
  };
})();

/* Milagron: Favorilerim masaüstü — "+ Yeni liste" kapağı ve liste ürün sayısı */
;(function(){
  function run(){
    var ph=document.querySelector('.gw-wl-page-placeholder'); if(!ph) return;
    var sc=ph.querySelector('.gw-wl-card-list-scroll');
    if(sc && !sc.querySelector('.mg-wl-newtile')){
      var b=document.createElement('button'); b.type='button'; b.className='mg-wl-newtile';
      b.innerHTML='<span aria-hidden="true">+</span><b>Yeni liste</b>';
      b.addEventListener('click',function(){ var x=ph.querySelector('.gw-wl-v2 > .gw-inline-stack .gw-btn--mode-link'); if(x) x.click(); });
      sc.appendChild(b);
    }
    var t=ph.querySelector('.gw-wl-title'), act=ph.querySelector('.gw-wl-card:has(.gw-wl-card__thumbnail--active) .gw-wl-card__wishlist-count');
    var n=act?parseInt(act.textContent,10):ph.querySelectorAll('.gw-wl-product-card').length;
    if(t){ var v=(n||0)+' ürün'; if(t.getAttribute('data-mg-count')!==v) t.setAttribute('data-mg-count',v); }
  }
  var q=0; new MutationObserver(function(){ if(!q) q=setTimeout(function(){ q=0; run(); },120); }).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();

/* Milagron: Favorilerim ürün kartları koleksiyon kartı gibi — marka, ad, fiyat merdiveni, Renk/Beden satırları, % rozeti */
;(function(){
  var data={}, pend={};
  function money(c){ return (c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL'; }
  function rateFrom(txt){ var it=[]; try{ it=JSON.parse(txt); }catch(e){ it=[{text:txt}]; } if(!Array.isArray(it)) it=[it]; for(var i=0;i<it.length;i++){ var m=/Sepette\s*%\s*(\d+(?:[.,]\d+)?)/i.exec((it[i]&&it[i].text)||''); if(m) return parseFloat(m[1].replace(',','.')); } return 0; }
  function load(h){
    if(data[h]) return Promise.resolve(data[h]); if(pend[h]) return pend[h];
    pend[h]=Promise.all([fetch('/products/'+h+'.js').then(function(r){return r.json()}), fetch('/products/'+h+'?view=mgsp').then(function(r){return r.ok?r.text():'[]'}).catch(function(){return '[]'})])
      .then(function(a){ data[h]={p:a[0], rate:rateFrom(a[1])}; return data[h]; }).catch(function(){ return null; });
    return pend[h];
  }
  var SWM=null; function swMap(){ if(SWM) return SWM; SWM={}; String(window.MG_SW||'').split(/\r?\n/).forEach(function(l){ var i=l.indexOf(':'); if(i<1) return; var k=mgcNorm(l.slice(0,i)), v=l.slice(i+1).trim(); if(k&&v&&!(k in SWM)) SWM[k]=v; }); return SWM; }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]}); }
  function render(card,d,vid){
    var p=d.p, v=(p.variants||[]).filter(function(x){return String(x.id)===String(vid)})[0]||(p.variants||[])[0]; if(!v) return;
    var box=card.querySelector('.gw-wl-product-card__content > .gw-block-stack'); if(!box) return;
    var tl=box.querySelector('.gw-wl-product-card__title-link');
    if(tl && !box.querySelector('.mg-fc-v')){ var vd=document.createElement('div'); vd.className='mg-fc-v'; vd.textContent=p.vendor||''; tl.parentNode.insertBefore(vd,tl); }
    var cur=v.price, cmp=v.compare_at_price&&v.compare_at_price>cur?v.compare_at_price:0, r=d.rate, h='';
    if(cmp) h+='<s>'+money(cmp)+'</s>'; else if(r) h+='<s>'+money(cur)+'</s>';
    if(cmp) h+='<span class="mg-wp__r mg-wp__ind'+(r?' mg-wp__x':'')+'"><i>İndirim</i><b>'+money(cur)+'</b></span>';
    else if(!r) h+='<span class="mg-wp__r"><b>'+money(cur)+'</b></span>';
    if(r) h+='<span class="mg-wp__r mg-wp__sp"><i>Sepette</i><b>'+money(Math.round(cur*(100-r)/100))+'</b></span>';
    var pb=box.querySelector('.mg-wp'); if(!pb){ pb=document.createElement('div'); pb.className='mg-wp'; box.appendChild(pb); } pb.innerHTML=h;
    var rows='', map=swMap();
    (p.options||[]).forEach(function(o,i){
      var name=(o.name||o), val=v['option'+(i+1)]; if(!val||/^default title$/i.test(val)) return;
      if(/cinsiyet|gender/i.test(name)) return;
      if(/renk|color|colour/i.test(name)){
        var bg=''; try{ bg=mgcBg(mgcResolve(val,map)); }catch(e){}
        if(bg) rows+='<div class="mg-fc-row mg-fc-row--renk"><span class="mg-fc-lbl">Renk</span><span class="mg-fc-sw" style="background:'+bg+'" title="'+esc(val)+'"></span></div>';
        else rows+='<div class="mg-fc-row"><span class="mg-fc-lbl">Renk</span><span class="mg-fc-chip">'+esc(val)+'</span></div>';
      } else rows+='<div class="mg-fc-row"><span class="mg-fc-lbl">'+esc(/beden|size/i.test(name)?'Beden':name)+'</span><span class="mg-fc-chip">'+esc(val)+'</span></div>';
    });
    var rb=box.querySelector('.mg-fc-rows'); if(!rb){ rb=document.createElement('div'); rb.className='mg-fc-rows'; box.insertBefore(rb,pb); } rb.innerHTML=rows;
    var iw=card.querySelector('.gw-wl-product-card__image-wrap');
    if(iw){ var pc=iw.querySelector('.mg-fc-pct'); var pct=cmp?Math.round((1-cur/cmp)*100):0;
      if(pct>0){ if(!pc){ pc=document.createElement('span'); pc.className='mg-fc-pct'; iw.appendChild(pc); } pc.textContent='%'+pct; } else if(pc) pc.remove(); }
    card.classList.add('mg-fc');
  }
  function run(){
    document.querySelectorAll('.gw-wl-page-placeholder .gw-wl-product-card').forEach(function(card){
      var a=card.querySelector('.gw-wl-product-card__title-link'); if(!a) return;
      var href=a.getAttribute('href')||'', key=href; if(card._mgFc===key) return; card._mgFc=key;
      var m=/\/products\/([^/?#]+)/.exec(href); if(!m) return; var vid=(/variant=(\d+)/.exec(href)||[])[1];
      load(m[1]).then(function(d){ if(d && card._mgFc===key) render(card,d,vid); });
    });
  }
  var q=0; new MutationObserver(function(){ if(!q) q=setTimeout(function(){ q=0; run(); },150); }).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();

/* Milagron: mobilde klavye açıkken alt menüyü gizle (iOS'ta klavyenin üstünde yüzmesin) */
;(function(){
  if (window.__mgKb) return; window.__mgKb = 1;
  var mq = window.matchMedia('(max-width: 767.98px)'), t = 0;
  function isText(el){
    if (!el || !el.tagName) return false;
    if (el.isContentEditable || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
    if (el.tagName !== 'INPUT') return false;
    return !/^(checkbox|radio|button|submit|reset|range|color|file|image|hidden)$/i.test(el.type || 'text');
  }
  var vv = window.visualViewport, H = 0;
  function sync(){
    var on = mq.matches && isText(document.activeElement);
    if (on && vv) {
      var full = Math.max(H, window.innerHeight);
      on = (full - vv.height) > 140;
    }
    document.documentElement.classList.toggle('mg-kb', !!on);
  }
  function remember(){ if (!isText(document.activeElement)) H = Math.max(window.innerHeight, vv ? vv.height : 0); }
  remember();
  document.addEventListener('focusin', function(e){
    if (!mq.matches || !isText(e.target)) return;
    clearTimeout(t);
    if (!vv) { document.documentElement.classList.add('mg-kb'); return; }
    t = setTimeout(sync, 350);
  }, true);
  document.addEventListener('focusout', function(){
    clearTimeout(t);
    t = setTimeout(sync, 120);
  }, true);
  if (vv) vv.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(function(){ remember(); sync(); }, 60); });
  window.addEventListener('orientationchange', function(){ H = 0; setTimeout(function(){ remember(); sync(); }, 400); });
})();


/* Milagron: Marka Vitrini kartı = koleksiyon kartı (fiyat merdiveni, Renk + Beden satırları) */
;(function(){
  if (window.__mgBsCard) return; window.__mgBsCard = 1;
  var cache = {}, pend = {};
  function money(c){ return (c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL'; }
  function esc(x){ return String(x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]}); }
  function rateOf(card){
    var t = card.querySelector('[data-efx-tags]'), raw = t ? t.getAttribute('data-efx-tags') : '';
    var m = /Sepette\s*%\s*(\d+(?:[.,]\d+)?)/i.exec(raw || ''); return m ? parseFloat(m[1].replace(',','.')) : 0;
  }
  function load(h){
    if (cache[h]) return Promise.resolve(cache[h]); if (pend[h]) return pend[h];
    return pend[h] = fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){ cache[h] = p; return p; }).catch(function(){ return null; });
  }
  function render(card, p){
    var info = card.querySelector('.efx-bs__card-info'); if (!info || !p) return;
    var vs = p.variants || [], v = vs.filter(function(x){ return x.available; })[0] || vs[0]; if (!v) return;
    var rate = rateOf(card), cur = v.price, cmp = v.compare_at_price > cur ? v.compare_at_price : 0, h = '';
    if (cmp) h += '<s>' + money(cmp) + '</s>'; else if (rate) h += '<s>' + money(cur) + '</s>';
    if (cmp) h += '<span class="mg-wp__r mg-wp__ind' + (rate ? ' mg-wp__x' : '') + '"><i>İndirim</i><b>' + money(cur) + '</b></span>';
    else if (!rate) h += '<span class="mg-wp__r"><b>' + money(cur) + '</b></span>';
    if (rate) h += '<span class="mg-wp__r mg-wp__sp"><i>Sepette</i><b>' + money(Math.round(cur * (100 - rate) / 100)) + '</b></span>';
    var pr = info.querySelector('.efx-bs__price');
    var box = info.querySelector('.mg-bs-p');
    if (!box) { box = document.createElement('div'); box.className = 'mg-bs-p'; if (pr) pr.parentNode.insertBefore(box, pr); else info.appendChild(box); }
    box.innerHTML = '<div class="mg-wp">' + h + '</div>';
    var rows = '', rowsB = '', opts = p.options || [];
    opts.forEach(function(o, i){
      var nm = String(o.name || o), key = 'option' + (i + 1);
      if (/renk|color|colour/i.test(nm)) {
        var c = v[key]; if (c && !/^default/i.test(c)) rows += '<div class="mg-row mg-row--renk"><span class="mg-row__lbl">Renk</span><i class="mg-sw is-on" data-c="' + esc(c) + '" title="' + esc(c) + '"></i></div>';
      } else if (/beden|size|numara/i.test(nm)) {
        var seen = {}, chips = '';
        vs.forEach(function(x){ var val = x[key]; if (x.available && val && !seen[val]) { seen[val] = 1; chips += '<span class="mg-chip">' + esc(val) + '</span>'; } });
        if (chips) rowsB += '<div class="mg-row mg-row--beden"><span class="mg-row__lbl">Beden</span>' + chips + '</div>';
      }
    });
    var rb = info.querySelector('.mg-bs-rows');
    if (!rb) { rb = document.createElement('div'); rb.className = 'mg-bs-rows'; box.parentNode.insertBefore(rb, box.nextSibling); }
    rb.innerHTML = rows + rowsB;
    card.classList.add('mg-bs-on');
    clearTimeout(window.__mgBsT); window.__mgBsT = setTimeout(function(){ eq(); window.dispatchEvent(new Event('resize')); }, 80);
  }
  // Aynı vitrindeki kartlarda fiyat ve Renk/Beden alanları eşit boy: alttaki kampanya kutusu hepsinde aynı hizada
  function eq(){
    document.querySelectorAll('.efx-bs').forEach(function(sec){
      ['.efx-bs__title', '.mg-bs-p', '.mg-bs-rows'].forEach(function(sel){
        var els = sec.querySelectorAll('.efx-bs__card.mg-bs-on ' + sel), mx = 0;
        els.forEach(function(e){ e.style.minHeight = ''; });
        els.forEach(function(e){ mx = Math.max(mx, e.offsetHeight); });
        if (mx) els.forEach(function(e){ e.style.minHeight = mx + 'px'; });
      });
    });
  }
  var eqT = 0; window.addEventListener('resize', function(){ clearTimeout(eqT); eqT = setTimeout(eq, 150); });
  function run(){
    document.querySelectorAll('.efx-bs__card:not([data-mg-bs])').forEach(function(card){
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || ''); if (!m) return;
      card.setAttribute('data-mg-bs', '1');
      load(m[1]).then(function(p){ render(card, p); });
    });
  }
  var q = 0; new MutationObserver(function(){ if (!q) q = setTimeout(function(){ q = 0; run(); }, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();


/* Milagron: masaüstü arama paneli — dışarı tıklayınca kapanır, X, karartma başlığın altından, sol sütun tek blok */
;(function(){
  if (window.__mgSDesk) return; window.__mgSDesk = 1;
  var mq = window.matchMedia('(min-width: 768px)');
  function ov(){ return document.querySelector('.efx-search-overlay'); }
  function isOpen(){ var o = ov(); return o && o.classList.contains('is-open'); }
  function close(){ var o = ov(); if (!o) return; var b = o.querySelector('.efx-popUp-close'); if (b) b.click(); }
  function headerBottom(){
    var inp = document.querySelector('input[name="q"]:not(.efx-drawer-input)'); if (!inp) return 0;
    var el = inp, best = 0;
    for (var i = 0; i < 8 && el && el !== document.body; i++) {
      var r = el.getBoundingClientRect();
      if (r.width >= window.innerWidth * .9 && r.bottom < 260) best = Math.max(best, r.bottom);
      el = el.parentElement;
    }
    return Math.round(best || inp.getBoundingClientRect().bottom + 12);
  }
  function layout(){
    var o = ov(); if (!o || !mq.matches) return;
    var def = o.querySelector('.efx-search-default'); if (!def) return;
    if (!def.querySelector(':scope > .mg-s-left')) {
      var L = document.createElement('div'); L.className = 'mg-s-left';
      var R = document.createElement('div'); R.className = 'mg-s-right';
      var rec = def.querySelector('.mg-s-recent'), side = def.querySelector('.efx-sidebar'), up = def.querySelector('.efx-upper-bar'), main = def.querySelector('.efx-main');
      if (!side || !up || !main) return;
      def.insertBefore(L, def.firstChild); def.insertBefore(R, L.nextSibling);
      if (rec) L.appendChild(rec); L.appendChild(side); R.appendChild(up); R.appendChild(main);
    }
  }
  function place(){
    var o = ov(); if (!o) return;
    if (!mq.matches || !isOpen()) { o.style.removeProperty('top'); return; }
    var t = headerBottom();
    if (t) { o.style.setProperty('top', t + 'px', 'important'); o.style.setProperty('--mg-s-top', t + 'px'); }
    layout(); pinX();
  }
  // X: kaydırılan içerikle kaymasın, yazıların/scrollbar'ın üstüne binmesin — panelin sağ üst köşesine sabit
  function pinX(){
    var o = ov(); if (!o) return;
    var w = o.querySelector('.custom-search-results__wrapper');
    var xs = o.querySelectorAll('.efx-popUp-close');
    if (!mq.matches || !isOpen() || !w) { xs.forEach(function(x){ x.classList.remove('mg-x-pin'); ['top','left','right'].forEach(function(k){ x.style.removeProperty(k); }); }); return; }
    var host = w.parentElement; if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var hr = host.getBoundingClientRect(), r = w.getBoundingClientRect(), sb = w.offsetWidth - w.clientWidth;
    var vis = null; xs.forEach(function(x){ if (!vis && (x.offsetParent || x.classList.contains('mg-x-pin'))) vis = x; });
    xs.forEach(function(x){ if (x !== vis) x.style.setProperty('display', 'none', 'important'); });
    if (!vis) return;
    if (vis.parentElement !== host) host.appendChild(vis);
    vis.classList.add('mg-x-pin'); vis.style.removeProperty('display'); vis.style.removeProperty('left');
    vis.style.setProperty('top', Math.round(r.top - hr.top + 14) + 'px', 'important');
    vis.style.setProperty('right', Math.round(hr.right - r.right + sb + 14) + 'px', 'important');
  }
  var pxq = 0;
  function pinLater(){ if (!pxq) pxq = requestAnimationFrame(function(){ pxq = 0; pinX(); }); }
  // açılınca konumla
  var watched = null;
  function watch(){
    var o = ov(); if (!o || o === watched) return; watched = o;
    new MutationObserver(function(){ place(); }).observe(o, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(pinLater).observe(o, { childList: true, subtree: true });
    place();
  }
  new MutationObserver(function(){ watch(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', place); window.addEventListener('scroll', function(){ if (isOpen()) place(); }, { passive: true });
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
  // panel dışına tıklayınca kapat (arama kutusu hariç)
  document.addEventListener('mousedown', function(e){
    if (!mq.matches || !isOpen()) return;
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.custom-search-results__wrapper')) return;
    if (t.closest('input[name="q"]') || t.closest('.efx-main-search, form[action*="/search"]')) return;
    close();
  }, true);
})();

/* Milagron: Ürün sayfası v2 — karar kartı, kart fiyat merdiveni, özellik ızgarası,
   mobil sabit sepet çubuğu, tasarımlı stok bildirimi penceresi (BIS.create) */
;(function(){
  if (window.__mgPd2) return; window.__mgPd2 = 1;
  var MONEY = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/;
  function num(t){ var m = MONEY.exec(String(t || '')); return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : 0; }
  function fmt(v){ try { return v.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; } catch (e) { return v.toFixed(2).replace('.', ',') + ' TL'; } }
  function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var ICO = {
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="#0B7A43" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.3-5.7M4 4v4h4"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="#0B7A43" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/></svg>',
    bell: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#141414" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>',
    ok: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0B7A43" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  function form(){ return document.querySelector('main product-form.product-info'); }

  /* ---- fiyat merdiveni ---- */
  function ladder(f){
    var box = f.querySelector('.product-info__price .price'); if (!box) return;
    var curEl = box.querySelector('.price__default .price__current'), wasEl = box.querySelector('.price__default .price__was');
    var cur = curEl ? num(curEl.textContent) : 0, was = wasEl ? num(wasEl.textContent) : 0;
    var spEl = box.querySelector('.mg-sp__val'), sp = spEl ? num(spEl.textContent) : 0;
    var nv = box.querySelector('.price__no-variant');
    var pp = box.querySelector('.mg-pp'); if (!pp) { pp = el('div', 'mg-pp'); box.appendChild(pp); }
    var h = '';
    if (!cur) { h = nv && !nv.hidden ? '<span class="mg-pp__nv">Lütfen farklı bir seçenek seçin</span>' : ''; }
    else {
      if (!(was > cur)) was = 0;
      if (!(sp > 0 && sp < cur)) sp = 0;
      if (was) h += '<s>' + fmt(was) + '</s>'; else if (sp) h += '<s>' + fmt(cur) + '</s>';
      if (was) h += '<span class="mg-pp__r mg-pp__ind' + (sp ? ' mg-pp__x' : '') + '"><i>İndirim</i><b>' + fmt(cur) + '</b></span>';
      else if (!sp) h += '<span class="mg-pp__r"><b>' + fmt(cur) + '</b></span>';
      if (sp) h += '<span class="mg-pp__r mg-pp__sp"><i>Sepette</i><b>' + fmt(sp) + '</b></span>';
    }
    if (pp.innerHTML !== h) pp.innerHTML = h;
    box.classList.add('mg-pp-on');
    f._mgPrice = { cur: cur, was: was, sp: sp };
    bar(f);
  }

  /* ---- yapı: kartlar ---- */
  function build(f){
    var col = f.querySelector('.product-column-right .product-form'); if (!col || col._mgPd) return;
    col._mgPd = 1; f.classList.add('mg-pd');
    var kids = Array.prototype.slice.call(col.children);
    var accStart = kids.findIndex ? kids.findIndex(function(k){ return k.classList && k.classList.contains('product-info-accordion'); }) : -1;
    if (accStart < 0) accStart = kids.length;
    var card = el('div', 'mg-pd-card mg-pd-main');
    col.insertBefore(card, kids[0]);
    kids.slice(0, accStart).forEach(function(k){ if (k.tagName !== 'STYLE' && k.tagName !== 'SCRIPT') card.appendChild(k); });
    // teklif kutusu
    var tag = card.querySelector('.mg-cbox--pdp, .custom-tag');
    if (tag && tag.parentElement && tag.parentElement !== card) tag.parentElement.classList.add('mg-offers');
    // güven satırları
    var tk = card.querySelector('.tahmini-kargo');
    var trust = el('div', 'mg-trust', '<span>' + ICO.ret + '<span><b>14 gün</b> içinde kolay iade</span></span><span>' + ICO.shield + '<span><b>En iyi fiyat garantisi</b> · 256 bit SSL güvenli ödeme</span></span>');
    if (tk) tk.parentNode.insertBefore(trust, tk.nextSibling); else card.appendChild(trust);
    // açılır bölümler kartı
    var rest = Array.prototype.slice.call(col.children).filter(function(k){ return k !== card; });
    var acc = el('div', 'mg-pd-card mg-pd-acc');
    var accs = rest.filter(function(k){ return k.classList && k.classList.contains('product-info-accordion'); });
    if (accs.length) { col.insertBefore(acc, accs[0]); accs.forEach(function(a){ acc.appendChild(a); }); }
    specs(col, acc);
  }

  /* ---- ürün özellikleri ızgarası (açıklamadaki "Ürün Özellikleri" listesinden) ---- */
  function findSpec(col){
    var d = col.querySelector('.product-info-accordion .disclosure__content'); if (!d) return null;
    var head = null, ps = d.querySelectorAll('p, h2, h3, h4, strong, b');
    for (var i = 0; i < ps.length; i++) { if (/^\s*Ürün Özellikleri\s*:?\s*$/i.test(ps[i].textContent)) { head = ps[i].closest('p, h2, h3, h4') || ps[i]; break; } }
    var ul = null;
    if (head) { var n = head.nextElementSibling; while (n && n.tagName !== 'UL' && n.tagName !== 'OL') { if (n.textContent.trim() && n.tagName !== 'BR') break; n = n.nextElementSibling; } if (n && (n.tagName === 'UL' || n.tagName === 'OL')) ul = n; }
    return ul ? { head: head, ul: ul } : null;
  }
  function hideSpec(col){
    if (!col.querySelector('.mg-pd-specs')) return;
    var x = findSpec(col); if (!x) return;
    if (x.head.style.display !== 'none') x.head.style.display = 'none';
    if (x.ul.style.display !== 'none') x.ul.style.display = 'none';
  }
  function specs(col, acc){
    var x = findSpec(col); if (!x) return;
    var head = x.head, ul = x.ul;
    var items = [];
    ul.querySelectorAll(':scope > li').forEach(function(li){
      var t = li.innerText || li.textContent; t = t.replace(/\s*\n\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();
      var at = t.indexOf(':');
      if (at > 0 && at < 40) items.push([t.slice(0, at).trim(), t.slice(at + 1).trim()]);
    });
    items = items.filter(function(x){ return x[0] && x[1]; });
    if (items.length < 2) return;
    var card = el('div', 'mg-pd-card mg-pd-specs');
    card.innerHTML = '<h2>Ürün özellikleri</h2><div class="mg-specs">' + items.map(function(x){ return '<div><small>' + esc(x[0]) + '</small><b>' + esc(x[1]) + '</b></div>'; }).join('') + '</div>';
    col.insertBefore(card, acc.parentNode === col ? acc : null);
    head.style.display = 'none'; ul.style.display = 'none';
  }

  /* ---- tükendi notu ---- */
  function sold(f){
    var btn = f.querySelector('.quantity-submit-row__submit .add-to-cart'); if (!btn) return;
    var isSold = btn.disabled;
    var wrap = btn.parentElement, note = wrap.querySelector('.mg-pd-sold');
    if (isSold && !note) { note = el('div', 'mg-pd-sold', 'Seçtiğin beden şu an tükendi. Stoğa geldiğinde e-postayla haber verelim.'); wrap.appendChild(note); }
    if (note) note.style.display = isSold ? '' : 'none';
    var bt = document.getElementById('BIS_trigger'); if (bt && bt.textContent.trim() !== 'Stoğa gelince haber ver' && /^\s*sto/i.test(bt.textContent)) bt.textContent = 'Stoğa gelince haber ver';
  }

  /* ---- mobil sabit çubuk ---- */
  var barEl = null, io = null;
  function bar(f){
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;
    var btn = f.querySelector('.quantity-submit-row__submit .add-to-cart'); if (!btn) return;
    if (!barEl) {
      barEl = el('div', 'mg-pd-bar', '<div class="mg-pd-bar__p"></div><button type="button"></button>');
      document.body.appendChild(barEl);
      barEl.querySelector('button').addEventListener('click', function(){
        var b = f.querySelector('.quantity-submit-row__submit .add-to-cart');
        if (b && b.disabled) { openBis(); return; }
        if (b) b.click();
      });
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function(es){ es.forEach(function(e){ barEl.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); });
        io.observe(btn.closest('.quantity-submit-row') || btn);
      }
    }
    var pr = f._mgPrice || {}, p = barEl.querySelector('.mg-pd-bar__p'), h = '';
    if (pr.sp) h = '<s>' + fmt(pr.was || pr.cur) + '</s><b class="is-sp">' + fmt(pr.sp) + '</b><small>Sepette</small>';
    else if (pr.cur) h = (pr.was ? '<s>' + fmt(pr.was) + '</s>' : '') + '<b>' + fmt(pr.cur) + '</b>';
    if (p.innerHTML !== h) p.innerHTML = h;
    var b2 = barEl.querySelector('button'), sd = btn.disabled;
    b2.textContent = sd ? 'Gelince haber ver' : 'Sepete ekle'; b2.classList.toggle('is-sold', sd);
  }

  /* ---- stok bildirimi penceresi ---- */
  var modal = null;
  function productData(f){
    if (f._mgPj) return f._mgPj;
    var s = f.querySelector('variant-picker script[type="application/json"], variant-picker script');
    var j = null; try { j = JSON.parse(s.textContent); } catch (e) {}
    f._mgPj = j; return j;
  }
  function curVariantId(f){ var i = f.querySelector('form.js-product-form input[name="id"]'); return i ? String(i.value) : ''; }
  function openBis(){
    var f = form(); if (!f) return;
    var j = productData(f) || {}, vs = (j.variants || []).filter(function(v){ return v && v.available === false; });
    var cv = curVariantId(f);
    if (!vs.length && cv) vs = [{ id: cv, title: '' }];
    var pid = (f.querySelector('input[name="product-id"]') || {}).value || '';
    var title = (f.querySelector('h1.product-title') || {}).textContent || '';
    var img = f.querySelector('.product-media-collage img, .main-image img, .product-media-wrapper img');
    var sel = vs.some(function(v){ return String(v.id) === cv; }) ? cv : (vs[0] ? String(vs[0].id) : '');
    if (!modal) {
      modal = el('div', 'mg-bis'); modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-labelledby', 'mgBisT');
      document.body.appendChild(modal);
      modal.addEventListener('click', function(e){ if (e.target === modal || e.target.closest('.mg-bis__x') || e.target.closest('[data-bis-close]')) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    }
    var all = (j.variants || []), parts = all.map(function(v){ return String(v.title || '').split(' / '); }), keep = [];
    if (parts.length) for (var k = 0; k < parts[0].length; k++) { var seen = {}; parts.forEach(function(x){ seen[x[k]] = 1; }); if (Object.keys(seen).length > 1) keep.push(k); }
    function short(v){ var x = String(v.title || '').split(' / '); return keep.length ? keep.map(function(k){ return x[k]; }).join(' / ') : v.title; }
    var showVars = vs.length > 1 || (vs[0] && vs[0].title && vs[0].title !== 'Default Title');
    modal.innerHTML = '<div class="mg-bis__box">' +
      '<button type="button" class="mg-bis__x" aria-label="Kapat"></button>' +
      '<div class="mg-bis__form"><div class="mg-bis__ic">' + ICO.bell + '</div>' +
      '<h3 id="mgBisT">Stoğa gelince haber verelim</h3><p class="mg-bis__lead">Ürün yeniden stoğa girdiğinde sana tek bir e-posta göndereceğiz.</p>' +
      '<div class="mg-bis__prod">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '') + '<div><b>' + esc(title.trim()) + '</b><span data-bis-vt></span></div></div>' +
      (showVars ? '<span class="mg-bis__lbl">Hangi seçenek için?</span><div class="mg-bis__vars">' + vs.map(function(v){ return '<button type="button" data-v="' + esc(v.id) + '">' + esc(short(v)) + '</button>'; }).join('') + '</div>' : '') +
      '<label class="mg-bis__lbl" for="mgBisE">E-posta adresin</label><input id="mgBisE" type="email" inputmode="email" autocomplete="email" placeholder="ornek@mail.com">' +
      '<p class="mg-bis__err" role="alert"></p><button type="button" class="mg-bis__go">Haber ver</button>' +
      '<p class="mg-bis__note">E-postan yalnızca bu bildirim için kullanılır.</p></div>' +
      '<div class="mg-bis__ok"><div class="mg-bis__ic">' + ICO.ok + '</div><h3>Tamamdır</h3><p>Ürün stoğa girdiğinde <b data-bis-mail></b> adresine haber vereceğiz.</p><button type="button" class="mg-bis__go" data-bis-close>Kapat</button></div></div>';
    function pick(id){ sel = String(id); modal.querySelectorAll('.mg-bis__vars button').forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-v') === sel); }); var v = vs.filter(function(x){ return String(x.id) === sel; })[0]; var vt = modal.querySelector('[data-bis-vt]'); if (vt) vt.textContent = v && v.title && v.title !== 'Default Title' ? v.title : ''; }
    modal.querySelectorAll('.mg-bis__vars button').forEach(function(b){ b.addEventListener('click', function(){ pick(b.getAttribute('data-v')); }); });
    pick(sel);
    var inp = modal.querySelector('#mgBisE'), err = modal.querySelector('.mg-bis__err'), go = modal.querySelector('.mg-bis__form .mg-bis__go');
    try { var saved = localStorage.getItem('mg_bis_mail'); if (saved) inp.value = saved; } catch (e) {}
    function fail(m){ err.textContent = m; err.classList.add('is-on'); go.disabled = false; go.textContent = 'Haber ver'; }
    function submit(){
      var m = (inp.value || '').trim(); err.classList.remove('is-on');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m)) { fail('Geçerli bir e-posta adresi yaz.'); inp.focus(); return; }
      if (!sel) { fail('Bir seçenek seç.'); return; }
      if (!window.BIS || typeof window.BIS.create !== 'function') { fail('Şu an kaydedemedik, birkaç saniye sonra tekrar dene.'); return; }
      go.disabled = true; go.textContent = 'Kaydediliyor…';
      var done = false;
      function ok(){ if (done) return; done = true; try { localStorage.setItem('mg_bis_mail', m); } catch (e) {} modal.querySelector('[data-bis-mail]').textContent = m; modal.classList.add('is-done'); }
      try {
        var r = window.BIS.create(m, sel, pid);
        if (r && typeof r.then === 'function') r.then(function(resp){
          if (resp && resp.status && String(resp.status).toUpperCase() !== 'OK') {
            var es = resp.errors || {}; var msg = (es.base && es.base[0]) || (es.email && ('E-posta ' + es.email[0])) || 'Kaydedemedik, tekrar dene.';
            done = true; fail(msg); return;
          }
          ok();
        }, function(){ done = true; fail('Kaydedemedik, tekrar dene.'); });
        else ok();
      } catch (e) { fail('Kaydedemedik, tekrar dene.'); }
    }
    go.addEventListener('click', submit);
    inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    modal.classList.remove('is-done'); modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function(){ if (!window.matchMedia('(max-width: 767.98px)').matches) inp.focus(); }, 60);
  }
  function close(){ if (!modal) return; modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('#BIS_trigger');
    if (!t || !t.closest('main product-form.product-info')) return;
    e.preventDefault(); e.stopImmediatePropagation(); openBis();
  }, true);
  window.mgOpenBis = openBis;

  /* ---- çalıştır + izle ---- */
  var t = 0;
  function run(){
    var f = form(); if (!f) return;
    build(f); ladder(f); sold(f); bar(f);
    var c = f.querySelector('.product-column-right .product-form'); if (c) hideSpec(c);
  }
  function later(){ clearTimeout(t); t = setTimeout(run, 40); }
  function init(){
    if (!document.body.classList.contains('template-product')) return;
    run();
    var f = form(); if (!f) return;
    new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++) { var n = ms[i].target; if (n.nodeType !== 1) n = n.parentElement; if (n && n.closest && (n.closest('.mg-pp') || n.closest('.mg-pd-bar'))) continue; later(); return; }
    }).observe(f, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'value'] });
    setTimeout(run, 800); setTimeout(run, 2500);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
